-- | GENERATED by tools/sync-deck.mjs - do not edit.
-- |
-- | Source: data/es-1000.csv (1000 words, ordered by frequency, most common first).
module Flashcards.Data.Deck.Spanish
  ( deck
  , fingerprint
  , pronunciations
  )
  where

import Flashcards.Types.Card (Card, Rank(..), Slug(..))
import Flashcards.Types.Pronunciation (Dialect)

-- | Content hash of what each rank means. Progress is keyed by slug, so this
-- | is no longer what protects it - it certifies that a rank still names the
-- | word it named, which is all that placing a pre-v5 payload needs.
fingerprint :: String
fingerprint = "4a37f1e7b883"

-- | The index into this deck is meaningful: it is the order cards are
-- | introduced in.
deck :: Array Card
deck =
  [ { rank: Rank 1, slug: Slug "yo", english: "I", word: "yo", example: "" }
  , { rank: Rank 2, slug: Slug "querer", english: "to want", word: "querer", example: "" }
  , { rank: Rank 3, slug: Slug "este", english: "this", word: "este", example: "" }
  , { rank: Rank 4, slug: Slug "sí", english: "yes", word: "sí", example: "" }
  , { rank: Rank 5, slug: Slug "no", english: "no", word: "no", example: "" }
  , { rank: Rank 6, slug: Slug "poder", english: "to be able to", word: "poder", example: "" }
  , { rank: Rank 7, slug: Slug "hablar", english: "to speak", word: "hablar", example: "" }
  , { rank: Rank 8, slug: Slug "encontrar", english: "to find", word: "encontrar", example: "" }
  , { rank: Rank 9, slug: Slug "tener", english: "to have (own)", word: "tener", example: "" }
  , { rank: Rank 10, slug: Slug "necesitar", english: "to need", word: "necesitar", example: "" }
  , { rank: Rank 11, slug: Slug "donde", english: "where (the place that)", word: "donde", example: "" }
  , { rank: Rank 12, slug: Slug "que", english: "that (linking clauses)", word: "que", example: "" }
  , { rank: Rank 13, slug: Slug "el / la", english: "the", word: "el / la", example: "" }
  , { rank: Rank 14, slug: Slug "lugar", english: "place", word: "lugar", example: "" }
  , { rank: Rank 15, slug: Slug "casa", english: "home", word: "casa", example: "" }
  , { rank: Rank 16, slug: Slug "algo", english: "something", word: "algo", example: "" }
  , { rank: Rank 17, slug: Slug "ese", english: "that (near you)", word: "ese", example: "" }
  , { rank: Rank 18, slug: Slug "y", english: "and", word: "y", example: "" }
  , { rank: Rank 19, slug: Slug "ver", english: "to see", word: "ver", example: "" }
  , { rank: Rank 20, slug: Slug "pero", english: "but", word: "pero", example: "" }
  , { rank: Rank 21, slug: Slug "ir(se)", english: "to go (go away/leave)", word: "ir(se)", example: "" }
  , { rank: Rank 22, slug: Slug "a", english: "to, at", word: "a", example: "" }
  , { rank: Rank 23, slug: Slug "decir", english: "to say", word: "decir", example: "" }
  , { rank: Rank 24, slug: Slug "o", english: "or", word: "o", example: "" }
  , { rank: Rank 25, slug: Slug "un", english: "a", word: "un", example: "" }
  , { rank: Rank 26, slug: Slug "más", english: "more", word: "más", example: "" }
  , { rank: Rank 27, slug: Slug "como", english: "as, like", word: "como", example: "" }
  , { rank: Rank 28, slug: Slug "se", english: "is, oneself", word: "se", example: "" }
  , { rank: Rank 29, slug: Slug "venir", english: "to come", word: "venir", example: "" }
  , { rank: Rank 30, slug: Slug "mi", english: "my", word: "mi", example: "" }
  , { rank: Rank 31, slug: Slug "ser", english: "to be (what it is)", word: "ser", example: "" }
  , { rank: Rank 32, slug: Slug "estar", english: "to be (how or where it is)", word: "estar", example: "" }
  , { rank: Rank 33, slug: Slug "vivir", english: "to live", word: "vivir", example: "" }
  , { rank: Rank 34, slug: Slug "pasar", english: "to pass", word: "pasar", example: "" }
  , { rank: Rank 35, slug: Slug "día", english: "day", word: "día", example: "" }
  , { rank: Rank 36, slug: Slug "año", english: "year", word: "año", example: "" }
  , { rank: Rank 37, slug: Slug "semana", english: "week", word: "semana", example: "" }
  , { rank: Rank 38, slug: Slug "mes", english: "month", word: "mes", example: "" }
  , { rank: Rank 39, slug: Slug "cada", english: "each", word: "cada", example: "" }
  , { rank: Rank 40, slug: Slug "tiempo", english: "time (duration)", word: "tiempo", example: "" }
  , { rank: Rank 41, slug: Slug "saber", english: "to know", word: "saber", example: "" }
  , { rank: Rank 42, slug: Slug "conocer", english: "to know (be familiar with)", word: "conocer", example: "" }
  , { rank: Rank 43, slug: Slug "hacer", english: "to do (to make)", word: "hacer", example: "" }
  , { rank: Rank 44, slug: Slug "practicar", english: "to practice", word: "practicar", example: "" }
  , { rank: Rank 45, slug: Slug "llegar", english: "to arrive", word: "llegar", example: "" }
  , { rank: Rank 46, slug: Slug "también", english: "too, also", word: "también", example: "" }
  , { rank: Rank 47, slug: Slug "cuando", english: "when", word: "cuando", example: "" }
  , { rank: Rank 48, slug: Slug "hasta", english: "until", word: "hasta", example: "" }
  , { rank: Rank 49, slug: Slug "mañana", english: "morning", word: "mañana", example: "" }
  , { rank: Rank 50, slug: Slug "él / ella", english: "he / she", word: "él / ella", example: "" }
  , { rank: Rank 51, slug: Slug "gustar", english: "is pleasing to (to like)", word: "gustar", example: "" }
  , { rank: Rank 52, slug: Slug "me", english: "me", word: "me", example: "" }
  , { rank: Rank 53, slug: Slug "te", english: "you (one person, object)", word: "te", example: "" }
  , { rank: Rank 54, slug: Slug "le", english: "you, him, her", word: "le", example: "" }
  , { rank: Rank 55, slug: Slug "nos", english: "us (object)", word: "nos", example: "" }
  , { rank: Rank 56, slug: Slug "les", english: "them", word: "les", example: "" }
  , { rank: Rank 57, slug: Slug "amigo", english: "friend", word: "amigo", example: "" }
  , { rank: Rank 58, slug: Slug "comida", english: "food", word: "comida", example: "" }
  , { rank: Rank 59, slug: Slug "otro", english: "other", word: "otro", example: "" }
  , { rank: Rank 60, slug: Slug "trabajo", english: "work (job)", word: "trabajo", example: "" }
  , { rank: Rank 61, slug: Slug "por", english: "for, through", word: "por", example: "" }
  , { rank: Rank 62, slug: Slug "para", english: "for, in order to", word: "para", example: "" }
  , { rank: Rank 63, slug: Slug "ejemplo", english: "example", word: "ejemplo", example: "" }
  , { rank: Rank 64, slug: Slug "de", english: "of", word: "de", example: "" }
  , { rank: Rank 65, slug: Slug "en", english: "in, on", word: "en", example: "" }
  , { rank: Rank 66, slug: Slug "con", english: "with", word: "con", example: "" }
  , { rank: Rank 67, slug: Slug "dar", english: "to give", word: "dar", example: "" }
  , { rank: Rank 68, slug: Slug "país", english: "country", word: "país", example: "" }
  , { rank: Rank 69, slug: Slug "hombre", english: "man", word: "hombre", example: "" }
  , { rank: Rank 70, slug: Slug "mujer", english: "woman", word: "mujer", example: "" }
  , { rank: Rank 71, slug: Slug "haber", english: "to have (done something)", word: "haber", example: "" }
  , { rank: Rank 72, slug: Slug "muy", english: "very", word: "muy", example: "" }
  , { rank: Rank 73, slug: Slug "mucho", english: "much", word: "mucho", example: "" }
  , { rank: Rank 74, slug: Slug "grande", english: "large", word: "grande", example: "" }
  , { rank: Rank 75, slug: Slug "menos", english: "less", word: "menos", example: "" }
  , { rank: Rank 76, slug: Slug "poco", english: "little", word: "poco", example: "" }
  , { rank: Rank 77, slug: Slug "cosa", english: "thing", word: "cosa", example: "" }
  , { rank: Rank 78, slug: Slug "si", english: "if", word: "si", example: "" }
  , { rank: Rank 79, slug: Slug "nuestro", english: "our", word: "nuestro", example: "" }
  , { rank: Rank 80, slug: Slug "siempre", english: "always", word: "siempre", example: "" }
  , { rank: Rank 81, slug: Slug "vida", english: "life", word: "vida", example: "" }
  , { rank: Rank 82, slug: Slug "después", english: "afterwards", word: "después", example: "" }
  , { rank: Rank 83, slug: Slug "entonces", english: "then", word: "entonces", example: "" }
  , { rank: Rank 84, slug: Slug "poner", english: "to put, place", word: "poner", example: "" }
  , { rank: Rank 85, slug: Slug "deber", english: "should, must, to owe", word: "deber", example: "" }
  , { rank: Rank 86, slug: Slug "bien", english: "well (properly)", word: "bien", example: "" }
  , { rank: Rank 87, slug: Slug "entre", english: "between", word: "entre", example: "" }
  , { rank: Rank 88, slug: Slug "palabra", english: "word", word: "palabra", example: "" }
  , { rank: Rank 89, slug: Slug "ahora", english: "now", word: "ahora", example: "" }
  , { rank: Rank 90, slug: Slug "aprender", english: "to learn", word: "aprender", example: "" }
  , { rank: Rank 91, slug: Slug "tu", english: "your", word: "tu", example: "" }
  , { rank: Rank 92, slug: Slug "creer", english: "to believe", word: "creer", example: "" }
  , { rank: Rank 93, slug: Slug "parecer", english: "is seeming to (to seem)", word: "parecer", example: "" }
  , { rank: Rank 94, slug: Slug "nada", english: "nothing", word: "nada", example: "" }
  , { rank: Rank 95, slug: Slug "todo", english: "all", word: "todo", example: "" }
  , { rank: Rank 96, slug: Slug "porque", english: "because", word: "porque", example: "" }
  , { rank: Rank 97, slug: Slug "ayudar", english: "to help", word: "ayudar", example: "" }
  , { rank: Rank 98, slug: Slug "pedir", english: "to ask for, to request", word: "pedir", example: "" }
  , { rank: Rank 99, slug: Slug "preguntar", english: "to ask (a question)", word: "preguntar", example: "" }
  , { rank: Rank 100, slug: Slug "qué", english: "what", word: "qué", example: "" }
  , { rank: Rank 101, slug: Slug "lo", english: "it, the, him", word: "lo", example: "" }
  , { rank: Rank 102, slug: Slug "su", english: "his, her, their", word: "su", example: "" }
  , { rank: Rank 103, slug: Slug "aquí", english: "here", word: "aquí", example: "" }
  , { rank: Rank 104, slug: Slug "ya", english: "already", word: "ya", example: "" }
  , { rank: Rank 105, slug: Slug "sin", english: "without", word: "sin", example: "" }
  , { rank: Rank 106, slug: Slug "vez", english: "time (an occasion)", word: "vez", example: "" }
  , { rank: Rank 107, slug: Slug "hay", english: "there is, there are", word: "hay", example: "" }
  , { rank: Rank 108, slug: Slug "sobre", english: "on, about", word: "sobre", example: "" }
  , { rank: Rank 109, slug: Slug "tú", english: "you (informal)", word: "tú", example: "" }
  , { rank: Rank 110, slug: Slug "alguno", english: "some, any (in questions)", word: "alguno", example: "" }
  , { rank: Rank 111, slug: Slug "mismo", english: "same", word: "mismo", example: "" }
  , { rank: Rank 112, slug: Slug "así", english: "like that, so", word: "así", example: "" }
  , { rank: Rank 113, slug: Slug "cómo", english: "how", word: "cómo", example: "" }
  , { rank: Rank 114, slug: Slug "dos", english: "two", word: "dos", example: "" }
  , { rank: Rank 115, slug: Slug "sólo", english: "only (pre-2010 spelling)", word: "sólo", example: "" }
  , { rank: Rank 116, slug: Slug "primero", english: "first", word: "primero", example: "" }
  , { rank: Rank 117, slug: Slug "desde", english: "from", word: "desde", example: "" }
  , { rank: Rank 118, slug: Slug "ni", english: "nor", word: "ni", example: "" }
  , { rank: Rank 119, slug: Slug "gracias", english: "thanks", word: "gracias", example: "" }
  , { rank: Rank 120, slug: Slug "bueno", english: "good", word: "bueno", example: "" }
  , { rank: Rank 121, slug: Slug "uno", english: "one", word: "uno", example: "" }
  , { rank: Rank 122, slug: Slug "usted", english: "you (formal)", word: "usted", example: "" }
  , { rank: Rank 123, slug: Slug "tanto", english: "so many, so much", word: "tanto", example: "" }
  , { rank: Rank 124, slug: Slug "señor", english: "Mr.", word: "señor", example: "" }
  , { rank: Rank 125, slug: Slug "tan", english: "such, as, so", word: "tan", example: "" }
  , { rank: Rank 126, slug: Slug "quién", english: "who", word: "quién", example: "" }
  , { rank: Rank 127, slug: Slug "parte", english: "part", word: "parte", example: "" }
  , { rank: Rank 128, slug: Slug "quedar", english: "is remaining to (to be left)", word: "quedar", example: "" }
  , { rank: Rank 129, slug: Slug "por favor", english: "please", word: "por favor", example: "" }
  , { rank: Rank 130, slug: Slug "dónde", english: "where? (asking)", word: "dónde", example: "" }
  , { rank: Rank 131, slug: Slug "nunca", english: "never", word: "nunca", example: "" }
  , { rank: Rank 132, slug: Slug "llevar", english: "to lead", word: "llevar", example: "" }
  , { rank: Rank 133, slug: Slug "dejar", english: "to leave behind, to let", word: "dejar", example: "" }
  , { rank: Rank 134, slug: Slug "verdad", english: "truth", word: "verdad", example: "" }
  , { rank: Rank 135, slug: Slug "seguir", english: "to follow", word: "seguir", example: "" }
  , { rank: Rank 136, slug: Slug "nuevo", english: "new", word: "nuevo", example: "" }
  , { rank: Rank 137, slug: Slug "pues", english: "so, then", word: "pues", example: "" }
  , { rank: Rank 138, slug: Slug "llamar(se)", english: "to call (be called/name)", word: "llamar(se)", example: "" }
  , { rank: Rank 139, slug: Slug "mejor", english: "best", word: "mejor", example: "" }
  , { rank: Rank 140, slug: Slug "pensar", english: "to think", word: "pensar", example: "" }
  , { rank: Rank 141, slug: Slug "aquel", english: "that (over there)", word: "aquel", example: "" }
  , { rank: Rank 142, slug: Slug "momento", english: "moment", word: "momento", example: "" }
  , { rank: Rank 143, slug: Slug "dios", english: "god", word: "dios", example: "" }
  , { rank: Rank 144, slug: Slug "sino", english: "but, rather", word: "sino", example: "" }
  , { rank: Rank 145, slug: Slug "salir", english: "to go out, to leave", word: "salir", example: "" }
  , { rank: Rank 146, slug: Slug "volver", english: "to return", word: "volver", example: "" }
  , { rank: Rank 147, slug: Slug "forma", english: "form", word: "forma", example: "" }
  , { rank: Rank 148, slug: Slug "antes", english: "before (in time)", word: "antes", example: "" }
  , { rank: Rank 149, slug: Slug "aunque", english: "although", word: "aunque", example: "" }
  , { rank: Rank 150, slug: Slug "mundo", english: "world", word: "mundo", example: "" }
  , { rank: Rank 151, slug: Slug "tres", english: "three", word: "tres", example: "" }
  , { rank: Rank 152, slug: Slug "tal", english: "such", word: "tal", example: "" }
  , { rank: Rank 153, slug: Slug "ahí", english: "there", word: "ahí", example: "" }
  , { rank: Rank 154, slug: Slug "tomar", english: "to take, to drink", word: "tomar", example: "" }
  , { rank: Rank 155, slug: Slug "cierto", english: "certain", word: "cierto", example: "" }
  , { rank: Rank 156, slug: Slug "hacia", english: "to, towards", word: "hacia", example: "" }
  , { rank: Rank 157, slug: Slug "caso", english: "case", word: "caso", example: "" }
  , { rank: Rank 158, slug: Slug "noche", english: "night", word: "noche", example: "" }
  , { rank: Rank 159, slug: Slug "sentir", english: "to feel", word: "sentir", example: "" }
  , { rank: Rank 160, slug: Slug "luego", english: "then, later", word: "luego", example: "" }
  , { rank: Rank 161, slug: Slug "alguien", english: "someone", word: "alguien", example: "" }
  , { rank: Rank 162, slug: Slug "tratar", english: "to treat, deal with", word: "tratar", example: "" }
  , { rank: Rank 163, slug: Slug "persona", english: "person", word: "persona", example: "" }
  , { rank: Rank 164, slug: Slug "mayor", english: "higher", word: "mayor", example: "" }
  , { rank: Rank 165, slug: Slug "último", english: "last", word: "último", example: "" }
  , { rank: Rank 166, slug: Slug "solo", english: "single", word: "solo", example: "" }
  , { rank: Rank 167, slug: Slug "propio", english: "own", word: "propio", example: "" }
  , { rank: Rank 168, slug: Slug "nadie", english: "no one", word: "nadie", example: "" }
  , { rank: Rank 169, slug: Slug "quien", english: "whoever", word: "quien", example: "" }
  , { rank: Rank 170, slug: Slug "nosotros", english: "we", word: "nosotros", example: "" }
  , { rank: Rank 171, slug: Slug "mirar", english: "to look", word: "mirar", example: "" }
  , { rank: Rank 172, slug: Slug "padre", english: "father", word: "padre", example: "" }
  , { rank: Rank 173, slug: Slug "hora", english: "time, hour", word: "hora", example: "" }
  , { rank: Rank 174, slug: Slug "gente", english: "people", word: "gente", example: "" }
  , { rank: Rank 175, slug: Slug "ninguno", english: "none", word: "ninguno", example: "" }
  , { rank: Rank 176, slug: Slug "dinero", english: "money", word: "dinero", example: "" }
  , { rank: Rank 177, slug: Slug "casi", english: "almost", word: "casi", example: "" }
  , { rank: Rank 178, slug: Slug "punto", english: "point", word: "punto", example: "" }
  , { rank: Rank 179, slug: Slug "hecho", english: "done (made)", word: "hecho", example: "" }
  , { rank: Rank 180, slug: Slug "durante", english: "during", word: "durante", example: "" }
  , { rank: Rank 181, slug: Slug "cualquier", english: "any (whichever)", word: "cualquier", example: "" }
  , { rank: Rank 182, slug: Slug "mano", english: "hand", word: "mano", example: "" }
  , { rank: Rank 183, slug: Slug "manera", english: "way", word: "manera", example: "" }
  , { rank: Rank 184, slug: Slug "cual", english: "which", word: "cual", example: "" }
  , { rank: Rank 185, slug: Slug "mientras", english: "while", word: "mientras", example: "" }
  , { rank: Rank 186, slug: Slug "contar", english: "to count", word: "contar", example: "" }
  , { rank: Rank 187, slug: Slug "fin", english: "end", word: "fin", example: "" }
  , { rank: Rank 188, slug: Slug "tipo", english: "type", word: "tipo", example: "" }
  , { rank: Rank 189, slug: Slug "claro", english: "clear", word: "claro", example: "" }
  , { rank: Rank 190, slug: Slug "además", english: "also, besides", word: "además", example: "" }
  , { rank: Rank 191, slug: Slug "empezar", english: "to start", word: "empezar", example: "" }
  , { rank: Rank 192, slug: Slug "esperar", english: "to wait", word: "esperar", example: "" }
  , { rank: Rank 193, slug: Slug "hoy", english: "today", word: "hoy", example: "" }
  , { rank: Rank 194, slug: Slug "lado", english: "side", word: "lado", example: "" }
  , { rank: Rank 195, slug: Slug "hijo", english: "son", word: "hijo", example: "" }
  , { rank: Rank 196, slug: Slug "allí", english: "there", word: "allí", example: "" }
  , { rank: Rank 197, slug: Slug "éste", english: "this one (pre-2010 spelling)", word: "éste", example: "" }
  , { rank: Rank 198, slug: Slug "problema", english: "problem", word: "problema", example: "" }
  , { rank: Rank 199, slug: Slug "acuerdo", english: "agreement", word: "acuerdo", example: "" }
  , { rank: Rank 200, slug: Slug "cuenta", english: "account", word: "cuenta", example: "" }
  , { rank: Rank 201, slug: Slug "medio", english: "half (middle)", word: "medio", example: "" }
  , { rank: Rank 202, slug: Slug "contra", english: "against", word: "contra", example: "" }
  , { rank: Rank 203, slug: Slug "fuera", english: "out", word: "fuera", example: "" }
  , { rank: Rank 204, slug: Slug "buscar", english: "to search", word: "buscar", example: "" }
  , { rank: Rank 205, slug: Slug "dentro", english: "within", word: "dentro", example: "" }
  , { rank: Rank 206, slug: Slug "largo", english: "long", word: "largo", example: "" }
  , { rank: Rank 207, slug: Slug "seguro", english: "safe, secure", word: "seguro", example: "" }
  , { rank: Rank 208, slug: Slug "existir", english: "to exist", word: "existir", example: "" }
  , { rank: Rank 209, slug: Slug "niño", english: "child", word: "niño", example: "" }
  , { rank: Rank 210, slug: Slug "entrar", english: "to enter", word: "entrar", example: "" }
  , { rank: Rank 211, slug: Slug "madre", english: "mother", word: "madre", example: "" }
  , { rank: Rank 212, slug: Slug "sin embargo", english: "however", word: "sin embargo", example: "" }
  , { rank: Rank 213, slug: Slug "único", english: "only one, unique", word: "único", example: "" }
  , { rank: Rank 214, slug: Slug "trabajar", english: "to work", word: "trabajar", example: "" }
  , { rank: Rank 215, slug: Slug "pequeño", english: "small", word: "pequeño", example: "" }
  , { rank: Rank 216, slug: Slug "alto", english: "high", word: "alto", example: "" }
  , { rank: Rank 217, slug: Slug "cambio", english: "change", word: "cambio", example: "" }
  , { rank: Rank 218, slug: Slug "escribir", english: "to write", word: "escribir", example: "" }
  , { rank: Rank 219, slug: Slug "cuatro", english: "four", word: "cuatro", example: "" }
  , { rank: Rank 220, slug: Slug "perder", english: "to lose", word: "perder", example: "" }
  , { rank: Rank 221, slug: Slug "historia", english: "history", word: "historia", example: "" }
  , { rank: Rank 222, slug: Slug "espera", english: "wait", word: "espera", example: "" }
  , { rank: Rank 223, slug: Slug "idea", english: "idea", word: "idea", example: "" }
  , { rank: Rank 224, slug: Slug "agua", english: "water", word: "agua", example: "" }
  , { rank: Rank 225, slug: Slug "producir", english: "to produce", word: "producir", example: "" }
  , { rank: Rank 226, slug: Slug "ciudad", english: "city", word: "ciudad", example: "" }
  , { rank: Rank 227, slug: Slug "estado", english: "state", word: "estado", example: "" }
  , { rank: Rank 228, slug: Slug "modo", english: "mode", word: "modo", example: "" }
  , { rank: Rank 229, slug: Slug "nombre", english: "name", word: "nombre", example: "" }
  , { rank: Rank 230, slug: Slug "ocurrir", english: "to occur", word: "ocurrir", example: "" }
  , { rank: Rank 231, slug: Slug "familia", english: "family", word: "familia", example: "" }
  , { rank: Rank 232, slug: Slug "realidad", english: "reality", word: "realidad", example: "" }
  , { rank: Rank 233, slug: Slug "entender", english: "to understand", word: "entender", example: "" }
  , { rank: Rank 234, slug: Slug "recibir", english: "to receive", word: "recibir", example: "" }
  , { rank: Rank 235, slug: Slug "obra", english: "work (of art)", word: "obra", example: "" }
  , { rank: Rank 236, slug: Slug "importante", english: "important", word: "importante", example: "" }
  , { rank: Rank 237, slug: Slug "conmigo", english: "with me", word: "conmigo", example: "" }
  , { rank: Rank 238, slug: Slug "mal", english: "wrong", word: "mal", example: "" }
  , { rank: Rank 239, slug: Slug "todavía", english: "still, yet", word: "todavía", example: "" }
  , { rank: Rank 240, slug: Slug "razón", english: "reason", word: "razón", example: "" }
  , { rank: Rank 241, slug: Slug "cuanto", english: "as much as", word: "cuanto", example: "" }
  , { rank: Rank 242, slug: Slug "bajo", english: "low; under", word: "bajo", example: "" }
  , { rank: Rank 243, slug: Slug "recordar", english: "to remember", word: "recordar", example: "" }
  , { rank: Rank 244, slug: Slug "grupo", english: "group", word: "grupo", example: "" }
  , { rank: Rank 245, slug: Slug "amor", english: "love", word: "amor", example: "" }
  , { rank: Rank 246, slug: Slug "mil", english: "thousand", word: "mil", example: "" }
  , { rank: Rank 247, slug: Slug "mío", english: "mine", word: "mío", example: "" }
  , { rank: Rank 248, slug: Slug "humano", english: "human", word: "humano", example: "" }
  , { rank: Rank 249, slug: Slug "terminar", english: "to finish, to end", word: "terminar", example: "" }
  , { rank: Rank 250, slug: Slug "permitir", english: "to allow", word: "permitir", example: "" }
  , { rank: Rank 251, slug: Slug "aparecer", english: "to appear", word: "aparecer", example: "" }
  , { rank: Rank 252, slug: Slug "conseguir", english: "to get", word: "conseguir", example: "" }
  , { rank: Rank 253, slug: Slug "tarde", english: "afternoon", word: "tarde", example: "" }
  , { rank: Rank 254, slug: Slug "comenzar", english: "to start", word: "comenzar", example: "" }
  , { rank: Rank 255, slug: Slug "varios", english: "several", word: "varios", example: "" }
  , { rank: Rank 256, slug: Slug "posible", english: "possible", word: "posible", example: "" }
  , { rank: Rank 257, slug: Slug "aún", english: "still, yet", word: "aún", example: "" }
  , { rank: Rank 258, slug: Slug "servir", english: "to serve", word: "servir", example: "" }
  , { rank: Rank 259, slug: Slug "general", english: "general", word: "general", example: "" }
  , { rank: Rank 260, slug: Slug "sacar", english: "to take out", word: "sacar", example: "" }
  , { rank: Rank 261, slug: Slug "relación", english: "relationship", word: "relación", example: "" }
  , { rank: Rank 262, slug: Slug "cinco", english: "five", word: "cinco", example: "" }
  , { rank: Rank 263, slug: Slug "cuerpo", english: "body", word: "cuerpo", example: "" }
  , { rank: Rank 264, slug: Slug "contigo", english: "with you", word: "contigo", example: "" }
  , { rank: Rank 265, slug: Slug "mantener", english: "to maintain", word: "mantener", example: "" }
  , { rank: Rank 266, slug: Slug "ante", english: "faced with", word: "ante", example: "" }
  , { rank: Rank 267, slug: Slug "principio", english: "principle", word: "principio", example: "" }
  , { rank: Rank 268, slug: Slug "resultar", english: "to result", word: "resultar", example: "" }
  , { rank: Rank 269, slug: Slug "igual", english: "equal", word: "igual", example: "" }
  , { rank: Rank 270, slug: Slug "demasiado", english: "too", word: "demasiado", example: "" }
  , { rank: Rank 271, slug: Slug "pueblo", english: "town", word: "pueblo", example: "" }
  , { rank: Rank 272, slug: Slug "segundo", english: "second", word: "segundo", example: "" }
  , { rank: Rank 273, slug: Slug "leer", english: "to read", word: "leer", example: "" }
  , { rank: Rank 274, slug: Slug "caer", english: "to fall", word: "caer", example: "" }
  , { rank: Rank 275, slug: Slug "cambiar", english: "to change", word: "cambiar", example: "" }
  , { rank: Rank 276, slug: Slug "ojo", english: "eye", word: "ojo", example: "" }
  , { rank: Rank 277, slug: Slug "adiós", english: "goodbye", word: "adiós", example: "" }
  , { rank: Rank 278, slug: Slug "calle", english: "street", word: "calle", example: "" }
  , { rank: Rank 279, slug: Slug "presentar", english: "to present", word: "presentar", example: "" }
  , { rank: Rank 280, slug: Slug "blanco", english: "white", word: "blanco", example: "" }
  , { rank: Rank 281, slug: Slug "crear", english: "to create", word: "crear", example: "" }
  , { rank: Rank 282, slug: Slug "abrir", english: "to open", word: "abrir", example: "" }
  , { rank: Rank 283, slug: Slug "libro", english: "book", word: "libro", example: "" }
  , { rank: Rank 284, slug: Slug "distinto", english: "different", word: "distinto", example: "" }
  , { rank: Rank 285, slug: Slug "fuerza", english: "force", word: "fuerza", example: "" }
  , { rank: Rank 286, slug: Slug "luz", english: "light", word: "luz", example: "" }
  , { rank: Rank 287, slug: Slug "según", english: "according to", word: "según", example: "" }
  , { rank: Rank 288, slug: Slug "santo", english: "saint", word: "santo", example: "" }
  , { rank: Rank 289, slug: Slug "frente", english: "front", word: "frente", example: "" }
  , { rank: Rank 290, slug: Slug "considerar", english: "to consider", word: "considerar", example: "" }
  , { rank: Rank 291, slug: Slug "realmente", english: "really", word: "realmente", example: "" }
  , { rank: Rank 292, slug: Slug "policía", english: "police", word: "policía", example: "" }
  , { rank: Rank 293, slug: Slug "oír", english: "to hear", word: "oír", example: "" }
  , { rank: Rank 294, slug: Slug "cuyo", english: "whose", word: "cuyo", example: "" }
  , { rank: Rank 295, slug: Slug "sentido", english: "sense", word: "sentido", example: "" }
  , { rank: Rank 296, slug: Slug "acabar", english: "to have just done; to finish", word: "acabar", example: "" }
  , { rank: Rank 297, slug: Slug "paso", english: "step", word: "paso", example: "" }
  , { rank: Rank 298, slug: Slug "situación", english: "situation", word: "situación", example: "" }
  , { rank: Rank 299, slug: Slug "serio", english: "serious (person)", word: "serio", example: "" }
  , { rank: Rank 300, slug: Slug "cabeza", english: "head", word: "cabeza", example: "" }
  , { rank: Rank 301, slug: Slug "bastante", english: "quite", word: "bastante", example: "" }
  , { rank: Rank 302, slug: Slug "hermano", english: "brother", word: "hermano", example: "" }
  , { rank: Rank 303, slug: Slug "convertir", english: "to convert", word: "convertir", example: "" }
  , { rank: Rank 304, slug: Slug "gracia", english: "grace", word: "gracia", example: "" }
  , { rank: Rank 305, slug: Slug "siglo", english: "century", word: "siglo", example: "" }
  , { rank: Rank 306, slug: Slug "pasado", english: "last, past", word: "pasado", example: "" }
  , { rank: Rank 307, slug: Slug "malo", english: "bad", word: "malo", example: "" }
  , { rank: Rank 308, slug: Slug "tierra", english: "land", word: "tierra", example: "" }
  , { rank: Rank 309, slug: Slug "papel", english: "paper", word: "papel", example: "" }
  , { rank: Rank 310, slug: Slug "cariño", english: "affection", word: "cariño", example: "" }
  , { rank: Rank 311, slug: Slug "vale", english: "valid, voucher", word: "vale", example: "" }
  , { rank: Rank 312, slug: Slug "tampoco", english: "neither", word: "tampoco", example: "" }
  , { rank: Rank 313, slug: Slug "social", english: "social", word: "social", example: "" }
  , { rank: Rank 314, slug: Slug "viejo", english: "old (aged)", word: "viejo", example: "" }
  , { rank: Rank 315, slug: Slug "señora", english: "Mrs.", word: "señora", example: "" }
  , { rank: Rank 316, slug: Slug "tema", english: "topic", word: "tema", example: "" }
  , { rank: Rank 317, slug: Slug "político", english: "political", word: "político", example: "" }
  , { rank: Rank 318, slug: Slug "Español", english: "Spanish", word: "Español", example: "" }
  , { rank: Rank 319, slug: Slug "muerto", english: "dead", word: "muerto", example: "" }
  , { rank: Rank 320, slug: Slug "ganar", english: "to win", word: "ganar", example: "" }
  , { rank: Rank 321, slug: Slug "formar", english: "to form", word: "formar", example: "" }
  , { rank: Rank 322, slug: Slug "clase", english: "class", word: "clase", example: "" }
  , { rank: Rank 323, slug: Slug "rápido", english: "fast", word: "rápido", example: "" }
  , { rank: Rank 324, slug: Slug "traer", english: "to bring", word: "traer", example: "" }
  , { rank: Rank 325, slug: Slug "partir", english: "to start from, to divide", word: "partir", example: "" }
  , { rank: Rank 326, slug: Slug "morir", english: "to die", word: "morir", example: "" }
  , { rank: Rank 327, slug: Slug "incluso", english: "even", word: "incluso", example: "" }
  , { rank: Rank 328, slug: Slug "suerte", english: "luck", word: "suerte", example: "" }
  , { rank: Rank 329, slug: Slug "campo", english: "field, country", word: "campo", example: "" }
  , { rank: Rank 330, slug: Slug "cuidado", english: "care", word: "cuidado", example: "" }
  , { rank: Rank 331, slug: Slug "aceptar", english: "to accept", word: "aceptar", example: "" }
  , { rank: Rank 332, slug: Slug "quizás", english: "perhaps", word: "quizás", example: "" }
  , { rank: Rank 333, slug: Slug "realizar", english: "to perform", word: "realizar", example: "" }
  , { rank: Rank 334, slug: Slug "ciento", english: "hundred", word: "ciento", example: "" }
  , { rank: Rank 335, slug: Slug "miedo", english: "fear", word: "miedo", example: "" }
  , { rank: Rank 336, slug: Slug "orden", english: "order", word: "orden", example: "" }
  , { rank: Rank 337, slug: Slug "puerta", english: "door", word: "puerta", example: "" }
  , { rank: Rank 338, slug: Slug "pronto", english: "soon", word: "pronto", example: "" }
  , { rank: Rank 339, slug: Slug "suponer", english: "to suppose", word: "suponer", example: "" }
  , { rank: Rank 340, slug: Slug "comprender", english: "to understand", word: "comprender", example: "" }
  , { rank: Rank 341, slug: Slug "final", english: "final", word: "final", example: "" }
  , { rank: Rank 342, slug: Slug "interés", english: "interest", word: "interés", example: "" }
  , { rank: Rank 343, slug: Slug "siguiente", english: "following", word: "siguiente", example: "" }
  , { rank: Rank 344, slug: Slug "vista", english: "view", word: "vista", example: "" }
  , { rank: Rank 345, slug: Slug "lograr", english: "to achieve", word: "lograr", example: "" }
  , { rank: Rank 346, slug: Slug "demás", english: "other, the rest", word: "demás", example: "" }
  , { rank: Rank 347, slug: Slug "os", english: "you (several people, object)", word: "os", example: "" }
  , { rank: Rank 348, slug: Slug "chico", english: "boy", word: "chico", example: "" }
  , { rank: Rank 349, slug: Slug "difícil", english: "difficult", word: "difícil", example: "" }
  , { rank: Rank 350, slug: Slug "cuánto", english: "how much", word: "cuánto", example: "" }
  , { rank: Rank 351, slug: Slug "número", english: "number", word: "número", example: "" }
  , { rank: Rank 352, slug: Slug "explicar", english: "to explain", word: "explicar", example: "" }
  , { rank: Rank 353, slug: Slug "venga", english: "come", word: "venga", example: "" }
  , { rank: Rank 354, slug: Slug "negro", english: "black", word: "negro", example: "" }
  , { rank: Rank 355, slug: Slug "camino", english: "road", word: "camino", example: "" }
  , { rank: Rank 356, slug: Slug "fondo", english: "background", word: "fondo", example: "" }
  , { rank: Rank 357, slug: Slug "voz", english: "voice", word: "voz", example: "" }
  , { rank: Rank 358, slug: Slug "estudio", english: "study", word: "estudio", example: "" }
  , { rank: Rank 359, slug: Slug "necesario", english: "necessary", word: "necesario", example: "" }
  , { rank: Rank 360, slug: Slug "allá", english: "there", word: "allá", example: "" }
  , { rank: Rank 361, slug: Slug "tocar", english: "to touch", word: "tocar", example: "" }
  , { rank: Rank 362, slug: Slug "valor", english: "value", word: "valor", example: "" }
  , { rank: Rank 363, slug: Slug "reconocer", english: "to recognize", word: "reconocer", example: "" }
  , { rank: Rank 364, slug: Slug "estudiar", english: "to study", word: "estudiar", example: "" }
  , { rank: Rank 365, slug: Slug "alcanzar", english: "to reach", word: "alcanzar", example: "" }
  , { rank: Rank 366, slug: Slug "nacer", english: "to be born", word: "nacer", example: "" }
  , { rank: Rank 367, slug: Slug "dirigir", english: "to direct", word: "dirigir", example: "" }
  , { rank: Rank 368, slug: Slug "correr", english: "to run", word: "correr", example: "" }
  , { rank: Rank 369, slug: Slug "feliz", english: "happy", word: "feliz", example: "" }
  , { rank: Rank 370, slug: Slug "medida", english: "measure", word: "medida", example: "" }
  , { rank: Rank 371, slug: Slug "menor", english: "lesser, younger", word: "menor", example: "" }
  , { rank: Rank 372, slug: Slug "guerra", english: "war", word: "guerra", example: "" }
  , { rank: Rank 373, slug: Slug "solamente", english: "only", word: "solamente", example: "" }
  , { rank: Rank 374, slug: Slug "esposa", english: "wife", word: "esposa", example: "" }
  , { rank: Rank 375, slug: Slug "utilizar", english: "to use", word: "utilizar", example: "" }
  , { rank: Rank 376, slug: Slug "adelante", english: "forward", word: "adelante", example: "" }
  , { rank: Rank 377, slug: Slug "centro", english: "center", word: "centro", example: "" }
  , { rank: Rank 378, slug: Slug "cuál", english: "which one", word: "cuál", example: "" }
  , { rank: Rank 379, slug: Slug "necesidad", english: "need", word: "necesidad", example: "" }
  , { rank: Rank 380, slug: Slug "condición", english: "condition", word: "condición", example: "" }
  , { rank: Rank 381, slug: Slug "pagar", english: "to pay", word: "pagar", example: "" }
  , { rank: Rank 382, slug: Slug "ello", english: "it", word: "ello", example: "" }
  , { rank: Rank 383, slug: Slug "falta", english: "lack", word: "falta", example: "" }
  , { rank: Rank 384, slug: Slug "muerte", english: "death", word: "muerte", example: "" }
  , { rank: Rank 385, slug: Slug "diez", english: "ten", word: "diez", example: "" }
  , { rank: Rank 386, slug: Slug "través", english: "through, across", word: "través", example: "" }
  , { rank: Rank 387, slug: Slug "antiguo", english: "ancient, former", word: "antiguo", example: "" }
  , { rank: Rank 388, slug: Slug "supuesto", english: "supposed", word: "supuesto", example: "" }
  , { rank: Rank 389, slug: Slug "edad", english: "age", word: "edad", example: "" }
  , { rank: Rank 390, slug: Slug "jugar", english: "to play", word: "jugar", example: "" }
  , { rank: Rank 391, slug: Slug "corazón", english: "heart", word: "corazón", example: "" }
  , { rank: Rank 392, slug: Slug "cara", english: "face", word: "cara", example: "" }
  , { rank: Rank 393, slug: Slug "jefe", english: "boss, chief", word: "jefe", example: "" }
  , { rank: Rank 394, slug: Slug "época", english: "era, time", word: "época", example: "" }
  , { rank: Rank 395, slug: Slug "color", english: "color", word: "color", example: "" }
  , { rank: Rank 396, slug: Slug "escuchar", english: "to listen", word: "escuchar", example: "" }
  , { rank: Rank 397, slug: Slug "ayuda", english: "help", word: "ayuda", example: "" }
  , { rank: Rank 398, slug: Slug "experiencia", english: "experience", word: "experiencia", example: "" }
  , { rank: Rank 399, slug: Slug "movimiento", english: "movement", word: "movimiento", example: "" }
  , { rank: Rank 400, slug: Slug "cumplir", english: "to fulfill", word: "cumplir", example: "" }
  , { rank: Rank 401, slug: Slug "especial", english: "special", word: "especial", example: "" }
  , { rank: Rank 402, slug: Slug "diferente", english: "different", word: "diferente", example: "" }
  , { rank: Rank 403, slug: Slug "pesar", english: "to weigh", word: "pesar", example: "" }
  , { rank: Rank 404, slug: Slug "posibilidad", english: "possibility", word: "posibilidad", example: "" }
  , { rank: Rank 405, slug: Slug "ofrecer", english: "to offer", word: "ofrecer", example: "" }
  , { rank: Rank 406, slug: Slug "arriba", english: "up", word: "arriba", example: "" }
  , { rank: Rank 407, slug: Slug "descubrir", english: "to discover", word: "descubrir", example: "" }
  , { rank: Rank 408, slug: Slug "hija", english: "daughter", word: "hija", example: "" }
  , { rank: Rank 409, slug: Slug "anterior", english: "previous", word: "anterior", example: "" }
  , { rank: Rank 410, slug: Slug "juego", english: "game", word: "juego", example: "" }
  , { rank: Rank 411, slug: Slug "levantar(se)", english: "to lift (to get up)", word: "levantar(se)", example: "" }
  , { rank: Rank 412, slug: Slug "pobre", english: "poor", word: "pobre", example: "" }
  , { rank: Rank 413, slug: Slug "aire", english: "air", word: "aire", example: "" }
  , { rank: Rank 414, slug: Slug "seis", english: "six", word: "seis", example: "" }
  , { rank: Rank 415, slug: Slug "intentar", english: "to try", word: "intentar", example: "" }
  , { rank: Rank 416, slug: Slug "junto", english: "together", word: "junto", example: "" }
  , { rank: Rank 417, slug: Slug "resultado", english: "result", word: "resultado", example: "" }
  , { rank: Rank 418, slug: Slug "usar", english: "to use", word: "usar", example: "" }
  , { rank: Rank 419, slug: Slug "decidir", english: "to decide", word: "decidir", example: "" }
  , { rank: Rank 420, slug: Slug "repetir", english: "to repeat", word: "repetir", example: "" }
  , { rank: Rank 421, slug: Slug "olvidar", english: "to forget", word: "olvidar", example: "" }
  , { rank: Rank 422, slug: Slug "ley", english: "law", word: "ley", example: "" }
  , { rank: Rank 423, slug: Slug "aspecto", english: "appearance", word: "aspecto", example: "" }
  , { rank: Rank 424, slug: Slug "pie", english: "foot", word: "pie", example: "" }
  , { rank: Rank 425, slug: Slug "valer", english: "to be worth", word: "valer", example: "" }
  , { rank: Rank 426, slug: Slug "especie", english: "species", word: "especie", example: "" }
  , { rank: Rank 427, slug: Slug "comer", english: "to eat", word: "comer", example: "" }
  , { rank: Rank 428, slug: Slug "servicio", english: "service", word: "servicio", example: "" }
  , { rank: Rank 429, slug: Slug "cerca", english: "close", word: "cerca", example: "" }
  , { rank: Rank 430, slug: Slug "mostrar", english: "to show", word: "mostrar", example: "" }
  , { rank: Rank 431, slug: Slug "actividad", english: "activity", word: "actividad", example: "" }
  , { rank: Rank 432, slug: Slug "tercero", english: "third", word: "tercero", example: "" }
  , { rank: Rank 433, slug: Slug "tío", english: "uncle", word: "tío", example: "" }
  , { rank: Rank 434, slug: Slug "ocupar", english: "to occupy", word: "ocupar", example: "" }
  , { rank: Rank 435, slug: Slug "cuestión", english: "matter, issue", word: "cuestión", example: "" }
  , { rank: Rank 436, slug: Slug "duda", english: "doubt", word: "duda", example: "" }
  , { rank: Rank 437, slug: Slug "siquiera", english: "at least", word: "siquiera", example: "" }
  , { rank: Rank 438, slug: Slug "diferencia", english: "difference", word: "diferencia", example: "" }
  , { rank: Rank 439, slug: Slug "mover", english: "to move", word: "mover", example: "" }
  , { rank: Rank 440, slug: Slug "continuar", english: "to continue", word: "continuar", example: "" }
  , { rank: Rank 441, slug: Slug "cantidad", english: "amount", word: "cantidad", example: "" }
  , { rank: Rank 442, slug: Slug "acción", english: "action", word: "acción", example: "" }
  , { rank: Rank 443, slug: Slug "suceder", english: "to happen", word: "suceder", example: "" }
  , { rank: Rank 444, slug: Slug "fijar", english: "to set", word: "fijar", example: "" }
  , { rank: Rank 445, slug: Slug "sociedad", english: "society", word: "sociedad", example: "" }
  , { rank: Rank 446, slug: Slug "referir", english: "to refer", word: "referir", example: "" }
  , { rank: Rank 447, slug: Slug "acercar", english: "to bring closer", word: "acercar", example: "" }
  , { rank: Rank 448, slug: Slug "capaz", english: "able", word: "capaz", example: "" }
  , { rank: Rank 449, slug: Slug "libre", english: "free", word: "libre", example: "" }
  , { rank: Rank 450, slug: Slug "natural", english: "natural", word: "natural", example: "" }
  , { rank: Rank 451, slug: Slug "dedicar", english: "to devote", word: "dedicar", example: "" }
  , { rank: Rank 452, slug: Slug "peso", english: "weight", word: "peso", example: "" }
  , { rank: Rank 453, slug: Slug "efecto", english: "effect", word: "efecto", example: "" }
  , { rank: Rank 454, slug: Slug "objeto", english: "object", word: "objeto", example: "" }
  , { rank: Rank 455, slug: Slug "doctor", english: "doctor", word: "doctor", example: "" }
  , { rank: Rank 456, slug: Slug "verdadero", english: "true", word: "verdadero", example: "" }
  , { rank: Rank 457, slug: Slug "suficiente", english: "enough", word: "suficiente", example: "" }
  , { rank: Rank 458, slug: Slug "joven", english: "young", word: "joven", example: "" }
  , { rank: Rank 459, slug: Slug "partido", english: "political party, match", word: "partido", example: "" }
  , { rank: Rank 460, slug: Slug "económico", english: "economic", word: "económico", example: "" }
  , { rank: Rank 461, slug: Slug "abajo", english: "below, downstairs", word: "abajo", example: "" }
  , { rank: Rank 462, slug: Slug "derecho", english: "right", word: "derecho", example: "" }
  , { rank: Rank 463, slug: Slug "primer", english: "first (before a noun)", word: "primer", example: "" }
  , { rank: Rank 464, slug: Slug "importancia", english: "importance", word: "importancia", example: "" }
  , { rank: Rank 465, slug: Slug "genial", english: "great", word: "genial", example: "" }
  , { rank: Rank 466, slug: Slug "sistema", english: "system", word: "sistema", example: "" }
  , { rank: Rank 467, slug: Slug "justo", english: "just", word: "justo", example: "" }
  , { rank: Rank 468, slug: Slug "viaje", english: "trip", word: "viaje", example: "" }
  , { rank: Rank 469, slug: Slug "suelo", english: "soil", word: "suelo", example: "" }
  , { rank: Rank 470, slug: Slug "respecto", english: "respect, in regards to", word: "respecto", example: "" }
  , { rank: Rank 471, slug: Slug "conocimiento", english: "knowledge", word: "conocimiento", example: "" }
  , { rank: Rank 472, slug: Slug "libertad", english: "freedom", word: "libertad", example: "" }
  , { rank: Rank 473, slug: Slug "encima", english: "above", word: "encima", example: "" }
  , { rank: Rank 474, slug: Slug "comprar", english: "to buy", word: "comprar", example: "" }
  , { rank: Rank 475, slug: Slug "común", english: "common", word: "común", example: "" }
  , { rank: Rank 476, slug: Slug "abierto", english: "open", word: "abierto", example: "" }
  , { rank: Rank 477, slug: Slug "próximo", english: "next", word: "próximo", example: "" }
  , { rank: Rank 478, slug: Slug "fuerte", english: "strong", word: "fuerte", example: "" }
  , { rank: Rank 479, slug: Slug "atención", english: "attention", word: "atención", example: "" }
  , { rank: Rank 480, slug: Slug "subir", english: "to rise", word: "subir", example: "" }
  , { rank: Rank 481, slug: Slug "esfuerzo", english: "effort", word: "esfuerzo", example: "" }
  , { rank: Rank 482, slug: Slug "evitar", english: "to avoid", word: "evitar", example: "" }
  , { rank: Rank 483, slug: Slug "resto", english: "rest", word: "resto", example: "" }
  , { rank: Rank 484, slug: Slug "interesar", english: "is interesting to (to interest)", word: "interesar", example: "" }
  , { rank: Rank 485, slug: Slug "atrás", english: "back, backwards", word: "atrás", example: "" }
  , { rank: Rank 486, slug: Slug "zona", english: "area", word: "zona", example: "" }
  , { rank: Rank 487, slug: Slug "proceso", english: "process", word: "proceso", example: "" }
  , { rank: Rank 488, slug: Slug "vivo", english: "alive", word: "vivo", example: "" }
  , { rank: Rank 489, slug: Slug "cerrar", english: "to close, shut", word: "cerrar", example: "" }
  , { rank: Rank 490, slug: Slug "vino", english: "wine", word: "vino", example: "" }
  , { rank: Rank 491, slug: Slug "echar", english: "to throw, cast", word: "echar", example: "" }
  , { rank: Rank 492, slug: Slug "responder", english: "to reply", word: "responder", example: "" }
  , { rank: Rank 493, slug: Slug "sufrir", english: "to suffer", word: "sufrir", example: "" }
  , { rank: Rank 494, slug: Slug "completo", english: "complete", word: "completo", example: "" }
  , { rank: Rank 495, slug: Slug "minuto", english: "minute", word: "minuto", example: "" }
  , { rank: Rank 496, slug: Slug "escuela", english: "school", word: "escuela", example: "" }
  , { rank: Rank 497, slug: Slug "contrario", english: "contrary", word: "contrario", example: "" }
  , { rank: Rank 498, slug: Slug "mesa", english: "table (furniture)", word: "mesa", example: "" }
  , { rank: Rank 499, slug: Slug "real", english: "real", word: "real", example: "" }
  , { rank: Rank 500, slug: Slug "ocasión", english: "occasion", word: "ocasión", example: "" }
  , { rank: Rank 501, slug: Slug "sangre", english: "blood", word: "sangre", example: "" }
  , { rank: Rank 502, slug: Slug "importar", english: "is important to (to matter)", word: "importar", example: "" }
  , { rank: Rank 503, slug: Slug "público", english: "public", word: "público", example: "" }
  , { rank: Rank 504, slug: Slug "coche", english: "car", word: "coche", example: "" }
  , { rank: Rank 505, slug: Slug "obtener", english: "to obtain", word: "obtener", example: "" }
  , { rank: Rank 506, slug: Slug "programa", english: "program", word: "programa", example: "" }
  , { rank: Rank 507, slug: Slug "lejos", english: "far", word: "lejos", example: "" }
  , { rank: Rank 508, slug: Slug "siete", english: "seven", word: "siete", example: "" }
  , { rank: Rank 509, slug: Slug "enorme", english: "huge", word: "enorme", example: "" }
  , { rank: Rank 510, slug: Slug "respuesta", english: "response", word: "respuesta", example: "" }
  , { rank: Rank 511, slug: Slug "línea", english: "line", word: "línea", example: "" }
  , { rank: Rank 512, slug: Slug "espacio", english: "space", word: "espacio", example: "" }
  , { rank: Rank 513, slug: Slug "nivel", english: "level", word: "nivel", example: "" }
  , { rank: Rank 514, slug: Slug "paz", english: "peace", word: "paz", example: "" }
  , { rank: Rank 515, slug: Slug "gobierno", english: "government", word: "gobierno", example: "" }
  , { rank: Rank 516, slug: Slug "cabo", english: "end, cape", word: "cabo", example: "" }
  , { rank: Rank 517, slug: Slug "vuelta", english: "return", word: "vuelta", example: "" }
  , { rank: Rank 518, slug: Slug "observar", english: "to observe", word: "observar", example: "" }
  , { rank: Rank 519, slug: Slug "indicar", english: "to indicate", word: "indicar", example: "" }
  , { rank: Rank 520, slug: Slug "pregunta", english: "question", word: "pregunta", example: "" }
  , { rank: Rank 521, slug: Slug "imagen", english: "image", word: "imagen", example: "" }
  , { rank: Rank 522, slug: Slug "carrera", english: "career", word: "carrera", example: "" }
  , { rank: Rank 523, slug: Slug "culpa", english: "fault", word: "culpa", example: "" }
  , { rank: Rank 524, slug: Slug "imaginar", english: "to imagine", word: "imaginar", example: "" }
  , { rank: Rank 525, slug: Slug "soler", english: "to be in the habit of", word: "soler", example: "" }
  , { rank: Rank 526, slug: Slug "ambos", english: "both", word: "ambos", example: "" }
  , { rank: Rank 527, slug: Slug "acompañar", english: "to accompany", word: "acompañar", example: "" }
  , { rank: Rank 528, slug: Slug "profundo", english: "deep", word: "profundo", example: "" }
  , { rank: Rank 529, slug: Slug "detener", english: "to stop", word: "detener", example: "" }
  , { rank: Rank 530, slug: Slug "desarrollar", english: "to develop", word: "desarrollar", example: "" }
  , { rank: Rank 531, slug: Slug "ocho", english: "eight", word: "ocho", example: "" }
  , { rank: Rank 532, slug: Slug "fácil", english: "easy", word: "fácil", example: "" }
  , { rank: Rank 533, slug: Slug "señalar", english: "to signal", word: "señalar", example: "" }
  , { rank: Rank 534, slug: Slug "elegir", english: "to choose", word: "elegir", example: "" }
  , { rank: Rank 535, slug: Slug "figura", english: "figure", word: "figura", example: "" }
  , { rank: Rank 536, slug: Slug "principal", english: "main", word: "principal", example: "" }
  , { rank: Rank 537, slug: Slug "dormir", english: "to sleep", word: "dormir", example: "" }
  , { rank: Rank 538, slug: Slug "animal", english: "animal", word: "animal", example: "" }
  , { rank: Rank 539, slug: Slug "base", english: "base", word: "base", example: "" }
  , { rank: Rank 540, slug: Slug "preparar", english: "to prepare", word: "preparar", example: "" }
  , { rank: Rank 541, slug: Slug "proponer", english: "to propose", word: "proponer", example: "" }
  , { rank: Rank 542, slug: Slug "demostrar", english: "to demonstrate, prove", word: "demostrar", example: "" }
  , { rank: Rank 543, slug: Slug "fiesta", english: "party, celebration", word: "fiesta", example: "" }
  , { rank: Rank 544, slug: Slug "significar", english: "to mean", word: "significar", example: "" }
  , { rank: Rank 545, slug: Slug "posición", english: "position", word: "posición", example: "" }
  , { rank: Rank 546, slug: Slug "cama", english: "bed", word: "cama", example: "" }
  , { rank: Rank 547, slug: Slug "motivo", english: "motive", word: "motivo", example: "" }
  , { rank: Rank 548, slug: Slug "prueba", english: "test", word: "prueba", example: "" }
  , { rank: Rank 549, slug: Slug "politica", english: "policy", word: "política", example: "" }
  , { rank: Rank 550, slug: Slug "nacional", english: "national", word: "nacional", example: "" }
  , { rank: Rank 551, slug: Slug "lleno", english: "full (filled up)", word: "lleno", example: "" }
  , { rank: Rank 552, slug: Slug "teléfono", english: "phone", word: "teléfono", example: "" }
  , { rank: Rank 553, slug: Slug "reunir", english: "to gather", word: "reunir", example: "" }
  , { rank: Rank 554, slug: Slug "faltar", english: "is missing to (to lack)", word: "faltar", example: "" }
  , { rank: Rank 555, slug: Slug "equipo", english: "team", word: "equipo", example: "" }
  , { rank: Rank 556, slug: Slug "dato", english: "datum", word: "dato", example: "" }
  , { rank: Rank 557, slug: Slug "desear", english: "to wish", word: "desear", example: "" }
  , { rank: Rank 558, slug: Slug "empresa", english: "company, firm", word: "empresa", example: "" }
  , { rank: Rank 559, slug: Slug "asunto", english: "issue", word: "asunto", example: "" }
  , { rank: Rank 560, slug: Slug "presencia", english: "presence", word: "presencia", example: "" }
  , { rank: Rank 561, slug: Slug "suyo", english: "his, hers, theirs", word: "suyo", example: "" }
  , { rank: Rank 562, slug: Slug "cultura", english: "culture", word: "cultura", example: "" }
  , { rank: Rank 563, slug: Slug "serie", english: "series", word: "serie", example: "" }
  , { rank: Rank 564, slug: Slug "millón", english: "million", word: "millón", example: "" }
  , { rank: Rank 565, slug: Slug "enseñar", english: "to teach", word: "enseñar", example: "" }
  , { rank: Rank 566, slug: Slug "construir", english: "to build", word: "construir", example: "" }
  , { rank: Rank 567, slug: Slug "oportunidad", english: "opportunity", word: "oportunidad", example: "" }
  , { rank: Rank 568, slug: Slug "vender", english: "to sell", word: "vender", example: "" }
  , { rank: Rank 569, slug: Slug "matar", english: "to kill", word: "matar", example: "" }
  , { rank: Rank 570, slug: Slug "representar", english: "to represent", word: "representar", example: "" }
  , { rank: Rank 571, slug: Slug "desaparecer", english: "to disappear", word: "desaparecer", example: "" }
  , { rank: Rank 572, slug: Slug "mandar", english: "to send, to order", word: "mandar", example: "" }
  , { rank: Rank 573, slug: Slug "carácter", english: "character (nature)", word: "carácter", example: "" }
  , { rank: Rank 574, slug: Slug "adónde", english: "where to? (asking)", word: "adónde", example: "" }
  , { rank: Rank 575, slug: Slug "mayoría", english: "most", word: "mayoría", example: "" }
  , { rank: Rank 576, slug: Slug "rojo", english: "red", word: "rojo", example: "" }
  , { rank: Rank 577, slug: Slug "tras", english: "after, behind (formal)", word: "tras", example: "" }
  , { rank: Rank 578, slug: Slug "superior", english: "top", word: "superior", example: "" }
  , { rank: Rank 579, slug: Slug "andar", english: "to walk", word: "andar", example: "" }
  , { rank: Rank 580, slug: Slug "corto", english: "short", word: "corto", example: "" }
  , { rank: Rank 581, slug: Slug "autor", english: "author", word: "autor", example: "" }
  , { rank: Rank 582, slug: Slug "cuarto", english: "fourth", word: "cuarto", example: "" }
  , { rank: Rank 583, slug: Slug "cielo", english: "sky", word: "cielo", example: "" }
  , { rank: Rank 584, slug: Slug "conocido", english: "known", word: "conocido", example: "" }
  , { rank: Rank 585, slug: Slug "preferir", english: "to prefer", word: "preferir", example: "" }
  , { rank: Rank 586, slug: Slug "recuerdo", english: "memory (a recollection)", word: "recuerdo", example: "" }
  , { rank: Rank 587, slug: Slug "asegurar", english: "to ensure", word: "asegurar", example: "" }
  , { rank: Rank 588, slug: Slug "perdón", english: "forgiveness", word: "perdón", example: "" }
  , { rank: Rank 589, slug: Slug "función", english: "function", word: "función", example: "" }
  , { rank: Rank 590, slug: Slug "causa", english: "cause", word: "causa", example: "" }
  , { rank: Rank 591, slug: Slug "grave", english: "severe", word: "grave", example: "" }
  , { rank: Rank 592, slug: Slug "decisión", english: "decision", word: "decisión", example: "" }
  , { rank: Rank 593, slug: Slug "música", english: "music", word: "música", example: "" }
  , { rank: Rank 594, slug: Slug "extraño", english: "weird (foreign)", word: "extraño", example: "" }
  , { rank: Rank 595, slug: Slug "crecer", english: "to grow", word: "crecer", example: "" }
  , { rank: Rank 596, slug: Slug "surgir", english: "to emerge", word: "surgir", example: "" }
  , { rank: Rank 597, slug: Slug "película", english: "movie", word: "película", example: "" }
  , { rank: Rank 598, slug: Slug "expresión", english: "expression", word: "expresión", example: "" }
  , { rank: Rank 599, slug: Slug "marido", english: "husband", word: "marido", example: "" }
  , { rank: Rank 600, slug: Slug "alrededor", english: "around", word: "alrededor", example: "" }
  , { rank: Rank 601, slug: Slug "perro", english: "dog", word: "perro", example: "" }
  , { rank: Rank 602, slug: Slug "entregar", english: "to deliver", word: "entregar", example: "" }
  , { rank: Rank 603, slug: Slug "río", english: "river", word: "río", example: "" }
  , { rank: Rank 604, slug: Slug "exactamente", english: "exactly", word: "exactamente", example: "" }
  , { rank: Rank 605, slug: Slug "seguridad", english: "security", word: "seguridad", example: "" }
  , { rank: Rank 606, slug: Slug "rey", english: "king", word: "rey", example: "" }
  , { rank: Rank 607, slug: Slug "término", english: "term", word: "término", example: "" }
  , { rank: Rank 608, slug: Slug "colocar", english: "to place", word: "colocar", example: "" }
  , { rank: Rank 609, slug: Slug "metro", english: "metro", word: "metro", example: "" }
  , { rank: Rank 610, slug: Slug "médico", english: "doctor", word: "médico", example: "" }
  , { rank: Rank 611, slug: Slug "habitación", english: "room (bedroom)", word: "habitación", example: "" }
  , { rank: Rank 612, slug: Slug "establecer", english: "to establish", word: "establecer", example: "" }
  , { rank: Rank 613, slug: Slug "guardar", english: "to keep, to store", word: "guardar", example: "" }
  , { rank: Rank 614, slug: Slug "arte", english: "art", word: "arte", example: "" }
  , { rank: Rank 615, slug: Slug "par", english: "pair", word: "par", example: "" }
  , { rank: Rank 616, slug: Slug "iniciar", english: "to start", word: "iniciar", example: "" }
  , { rank: Rank 617, slug: Slug "fuego", english: "fire", word: "fuego", example: "" }
  , { rank: Rank 618, slug: Slug "bajar", english: "to go down, to lower", word: "bajar", example: "" }
  , { rank: Rank 619, slug: Slug "consecuencia", english: "consequence", word: "consecuencia", example: "" }
  , { rank: Rank 620, slug: Slug "notar", english: "to note", word: "notar", example: "" }
  , { rank: Rank 621, slug: Slug "acto", english: "act", word: "acto", example: "" }
  , { rank: Rank 622, slug: Slug "meter", english: "to put inside", word: "meter", example: "" }
  , { rank: Rank 623, slug: Slug "absoluto", english: "absolute", word: "absoluto", example: "" }
  , { rank: Rank 624, slug: Slug "pena", english: "penalty", word: "pena", example: "" }
  , { rank: Rank 625, slug: Slug "actuar", english: "to act", word: "actuar", example: "" }
  , { rank: Rank 626, slug: Slug "altura", english: "height", word: "altura", example: "" }
  , { rank: Rank 627, slug: Slug "deseo", english: "desire", word: "deseo", example: "" }
  , { rank: Rank 628, slug: Slug "afuera", english: "out, outside", word: "afuera", example: "" }
  , { rank: Rank 629, slug: Slug "precisamente", english: "precisely", word: "precisamente", example: "" }
  , { rank: Rank 630, slug: Slug "veinte", english: "twenty", word: "veinte", example: "" }
  , { rank: Rank 631, slug: Slug "sueño", english: "dream", word: "sueño", example: "" }
  , { rank: Rank 632, slug: Slug "pretender", english: "to intend, to claim", word: "pretender", example: "" }
  , { rank: Rank 633, slug: Slug "tarea", english: "task", word: "tarea", example: "" }
  , { rank: Rank 634, slug: Slug "café", english: "coffee", word: "café", example: "" }
  , { rank: Rank 635, slug: Slug "carta", english: "letter (you send)", word: "carta", example: "" }
  , { rank: Rank 636, slug: Slug "apenas", english: "barely, just", word: "apenas", example: "" }
  , { rank: Rank 637, slug: Slug "propiedad", english: "property", word: "propiedad", example: "" }
  , { rank: Rank 638, slug: Slug "producto", english: "product", word: "producto", example: "" }
  , { rank: Rank 639, slug: Slug "personal", english: "personal", word: "personal", example: "" }
  , { rank: Rank 640, slug: Slug "simplemente", english: "simply", word: "simplemente", example: "" }
  , { rank: Rank 641, slug: Slug "imposible", english: "impossible", word: "imposible", example: "" }
  , { rank: Rank 642, slug: Slug "gusto", english: "taste", word: "gusto", example: "" }
  , { rank: Rank 643, slug: Slug "acordar(se)", english: "to agree", word: "acordar", example: "" }
  , { rank: Rank 644, slug: Slug "sitio", english: "site", word: "sitio", example: "" }
  , { rank: Rank 645, slug: Slug "lengua", english: "language, tongue", word: "lengua", example: "" }
  , { rank: Rank 646, slug: Slug "cortar", english: "to cut", word: "cortar", example: "" }
  , { rank: Rank 647, slug: Slug "plan", english: "plan", word: "plan", example: "" }
  , { rank: Rank 648, slug: Slug "bebé", english: "baby", word: "bebé", example: "" }
  , { rank: Rank 649, slug: Slug "corresponder", english: "to correspond", word: "corresponder", example: "" }
  , { rank: Rank 650, slug: Slug "romper", english: "to break", word: "romper", example: "" }
  , { rank: Rank 651, slug: Slug "jamás", english: "never", word: "jamás", example: "" }
  , { rank: Rank 652, slug: Slug "adquirir", english: "to acquire", word: "adquirir", example: "" }
  , { rank: Rank 653, slug: Slug "arma", english: "weapon", word: "arma", example: "" }
  , { rank: Rank 654, slug: Slug "proyecto", english: "project", word: "proyecto", example: "" }
  , { rank: Rank 655, slug: Slug "memoria", english: "memory (the faculty)", word: "memoria", example: "" }
  , { rank: Rank 656, slug: Slug "origen", english: "origin", word: "origen", example: "" }
  , { rank: Rank 657, slug: Slug "elemento", english: "element", word: "elemento", example: "" }
  , { rank: Rank 658, slug: Slug "perdido", english: "lost", word: "perdido", example: "" }
  , { rank: Rank 659, slug: Slug "inglés", english: "English", word: "inglés", example: "" }
  , { rank: Rank 660, slug: Slug "mercado", english: "market", word: "mercado", example: "" }
  , { rank: Rank 661, slug: Slug "curso", english: "course", word: "curso", example: "" }
  , { rank: Rank 662, slug: Slug "lanzar", english: "to launch", word: "lanzar", example: "" }
  , { rank: Rank 663, slug: Slug "dado", english: "given", word: "dado", example: "" }
  , { rank: Rank 664, slug: Slug "aprovechar", english: "to take advantage of", word: "aprovechar", example: "" }
  , { rank: Rank 665, slug: Slug "interior", english: "interior", word: "interior", example: "" }
  , { rank: Rank 666, slug: Slug "duro", english: "hard", word: "duro", example: "" }
  , { rank: Rank 667, slug: Slug "apoyar", english: "to support", word: "apoyar", example: "" }
  , { rank: Rank 668, slug: Slug "peor", english: "worse", word: "peor", example: "" }
  , { rank: Rank 669, slug: Slug "negar", english: "to deny", word: "negar", example: "" }
  , { rank: Rank 670, slug: Slug "avanzar", english: "to advance", word: "avanzar", example: "" }
  , { rank: Rank 671, slug: Slug "uso", english: "usage", word: "uso", example: "" }
  , { rank: Rank 672, slug: Slug "brazo", english: "arm", word: "brazo", example: "" }
  , { rank: Rank 673, slug: Slug "profesor", english: "teacher, professor", word: "profesor", example: "" }
  , { rank: Rank 674, slug: Slug "resolver", english: "to resolve", word: "resolver", example: "" }
  , { rank: Rank 675, slug: Slug "futuro", english: "future", word: "futuro", example: "" }
  , { rank: Rank 676, slug: Slug "mitad", english: "half", word: "mitad", example: "" }
  , { rank: Rank 677, slug: Slug "ropa", english: "clothing", word: "ropa", example: "" }
  , { rank: Rank 678, slug: Slug "costar", english: "is costly to (to cost)", word: "costar", example: "" }
  , { rank: Rank 679, slug: Slug "rico", english: "rich", word: "rico", example: "" }
  , { rank: Rank 680, slug: Slug "total", english: "total", word: "total", example: "" }
  , { rank: Rank 681, slug: Slug "exigir", english: "to require", word: "exigir", example: "" }
  , { rank: Rank 682, slug: Slug "opinión", english: "opinion", word: "opinión", example: "" }
  , { rank: Rank 683, slug: Slug "aumentar", english: "to increase", word: "aumentar", example: "" }
  , { rank: Rank 684, slug: Slug "recoger", english: "to collect", word: "recoger", example: "" }
  , { rank: Rank 685, slug: Slug "boca", english: "mouth", word: "boca", example: "" }
  , { rank: Rank 686, slug: Slug "dirección", english: "address", word: "dirección", example: "" }
  , { rank: Rank 687, slug: Slug "puro", english: "pure", word: "puro", example: "" }
  , { rank: Rank 688, slug: Slug "presidente", english: "president", word: "presidente", example: "" }
  , { rank: Rank 689, slug: Slug "abandonar", english: "to abandon", word: "abandonar", example: "" }
  , { rank: Rank 690, slug: Slug "pieza", english: "piece", word: "pieza", example: "" }
  , { rank: Rank 691, slug: Slug "anoche", english: "last night", word: "anoche", example: "" }
  , { rank: Rank 692, slug: Slug "profesional", english: "professional", word: "profesional", example: "" }
  , { rank: Rank 693, slug: Slug "imponer", english: "to impose", word: "imponer", example: "" }
  , { rank: Rank 694, slug: Slug "acerca", english: "concerning", word: "acerca", example: "" }
  , { rank: Rank 695, slug: Slug "obligar", english: "to force", word: "obligar", example: "" }
  , { rank: Rank 696, slug: Slug "físico", english: "physical", word: "físico", example: "" }
  , { rank: Rank 697, slug: Slug "actitud", english: "attitude", word: "actitud", example: "" }
  , { rank: Rank 698, slug: Slug "mar", english: "sea", word: "mar", example: "" }
  , { rank: Rank 699, slug: Slug "entrada", english: "entry", word: "entrada", example: "" }
  , { rank: Rank 700, slug: Slug "contacto", english: "contact", word: "contacto", example: "" }
  , { rank: Rank 701, slug: Slug "aplicar", english: "to apply", word: "aplicar", example: "" }
  , { rank: Rank 702, slug: Slug "correcto", english: "correct", word: "correcto", example: "" }
  , { rank: Rank 703, slug: Slug "capital", english: "capital", word: "capital", example: "" }
  , { rank: Rank 704, slug: Slug "título", english: "title", word: "título", example: "" }
  , { rank: Rank 705, slug: Slug "detrás", english: "behind", word: "detrás", example: "" }
  , { rank: Rank 706, slug: Slug "puesto", english: "post", word: "puesto", example: "" }
  , { rank: Rank 707, slug: Slug "material", english: "material", word: "material", example: "" }
  , { rank: Rank 708, slug: Slug "golpe", english: "blow", word: "golpe", example: "" }
  , { rank: Rank 709, slug: Slug "disponer", english: "to dispose", word: "disponer", example: "" }
  , { rank: Rank 710, slug: Slug "comunicación", english: "communication", word: "comunicación", example: "" }
  , { rank: Rank 711, slug: Slug "expresar", english: "to express", word: "expresar", example: "" }
  , { rank: Rank 712, slug: Slug "disculpe", english: "sorry", word: "disculpe", example: "" }
  , { rank: Rank 713, slug: Slug "simple", english: "simple", word: "simple", example: "" }
  , { rank: Rank 714, slug: Slug "totalmente", english: "completely", word: "totalmente", example: "" }
  , { rank: Rank 715, slug: Slug "provocar", english: "to provoke", word: "provocar", example: "" }
  , { rank: Rank 716, slug: Slug "normal", english: "normal", word: "normal", example: "" }
  , { rank: Rank 717, slug: Slug "defender", english: "to defend", word: "defender", example: "" }
  , { rank: Rank 718, slug: Slug "enfermedad", english: "disease", word: "enfermedad", example: "" }
  , { rank: Rank 719, slug: Slug "materia", english: "matter", word: "materia", example: "" }
  , { rank: Rank 720, slug: Slug "quitar", english: "to take away", word: "quitar", example: "" }
  , { rank: Rank 721, slug: Slug "conservar", english: "to conserve", word: "conservar", example: "" }
  , { rank: Rank 722, slug: Slug "moderno", english: "modern", word: "moderno", example: "" }
  , { rank: Rank 723, slug: Slug "hospital", english: "hospital", word: "hospital", example: "" }
  , { rank: Rank 724, slug: Slug "depender", english: "to depend", word: "depender", example: "" }
  , { rank: Rank 725, slug: Slug "naturaleza", english: "nature", word: "naturaleza", example: "" }
  , { rank: Rank 726, slug: Slug "capacidad", english: "capacity", word: "capacidad", example: "" }
  , { rank: Rank 727, slug: Slug "actual", english: "current, present-day", word: "actual", example: "" }
  , { rank: Rank 728, slug: Slug "marcar", english: "to mark", word: "marcar", example: "" }
  , { rank: Rank 729, slug: Slug "distancia", english: "distance", word: "distancia", example: "" }
  , { rank: Rank 730, slug: Slug "pleno", english: "full, in the middle of", word: "pleno", example: "" }
  , { rank: Rank 731, slug: Slug "perfecto", english: "perfect", word: "perfecto", example: "" }
  , { rank: Rank 732, slug: Slug "cerrado", english: "closed", word: "cerrado", example: "" }
  , { rank: Rank 733, slug: Slug "compartir", english: "to share", word: "compartir", example: "" }
  , { rank: Rank 734, slug: Slug "tranquilo", english: "quiet", word: "tranquilo", example: "" }
  , { rank: Rank 735, slug: Slug "información", english: "information", word: "información", example: "" }
  , { rank: Rank 736, slug: Slug "ambiente", english: "environment", word: "ambiente", example: "" }
  , { rank: Rank 737, slug: Slug "especialmente", english: "especially", word: "especialmente", example: "" }
  , { rank: Rank 738, slug: Slug "desarrollo", english: "development", word: "desarrollo", example: "" }
  , { rank: Rank 739, slug: Slug "sol", english: "sun", word: "sol", example: "" }
  , { rank: Rank 740, slug: Slug "consistir", english: "to consist", word: "consistir", example: "" }
  , { rank: Rank 741, slug: Slug "probablemente", english: "probably", word: "probablemente", example: "" }
  , { rank: Rank 742, slug: Slug "constituir", english: "to constitute", word: "constituir", example: "" }
  , { rank: Rank 743, slug: Slug "ayer", english: "yesterday", word: "ayer", example: "" }
  , { rank: Rank 744, slug: Slug "dispuesto", english: "willing (available)", word: "dispuesto", example: "" }
  , { rank: Rank 745, slug: Slug "cubrir", english: "to cover", word: "cubrir", example: "" }
  , { rank: Rank 746, slug: Slug "funcionar", english: "to function", word: "funcionar", example: "" }
  , { rank: Rank 747, slug: Slug "compañero", english: "partner", word: "compañero", example: "" }
  , { rank: Rank 748, slug: Slug "bonito", english: "nice", word: "bonito", example: "" }
  , { rank: Rank 749, slug: Slug "salida", english: "exit", word: "salida", example: "" }
  , { rank: Rank 750, slug: Slug "caber", english: "to fit", word: "caber", example: "" }
  , { rank: Rank 751, slug: Slug "conciencia", english: "awareness", word: "conciencia", example: "" }
  , { rank: Rank 752, slug: Slug "atender", english: "to meet", word: "atender", example: "" }
  , { rank: Rank 753, slug: Slug "enfermo", english: "sick", word: "enfermo", example: "" }
  , { rank: Rank 754, slug: Slug "increíble", english: "incredible", word: "increíble", example: "" }
  , { rank: Rank 755, slug: Slug "insistir", english: "to insist", word: "insistir", example: "" }
  , { rank: Rank 756, slug: Slug "costumbre", english: "custom", word: "costumbre", example: "" }
  , { rank: Rank 757, slug: Slug "tonto", english: "silly", word: "tonto", example: "" }
  , { rank: Rank 758, slug: Slug "noticia", english: "news", word: "noticia", example: "" }
  , { rank: Rank 759, slug: Slug "circunstancia", english: "circumstance", word: "circunstancia", example: "" }
  , { rank: Rank 760, slug: Slug "doler", english: "is painful to (to hurt)", word: "doler", example: "" }
  , { rank: Rank 761, slug: Slug "privado", english: "private", word: "privado", example: "" }
  , { rank: Rank 762, slug: Slug "estilo", english: "style", word: "estilo", example: "" }
  , { rank: Rank 763, slug: Slug "precio", english: "price", word: "precio", example: "" }
  , { rank: Rank 764, slug: Slug "popular", english: "popular", word: "popular", example: "" }
  , { rank: Rank 765, slug: Slug "sentar", english: "to sit", word: "sentar", example: "" }
  , { rank: Rank 766, slug: Slug "planta", english: "plant", word: "planta", example: "" }
  , { rank: Rank 767, slug: Slug "ése", english: "that one (pre-2010 spelling)", word: "ése", example: "" }
  , { rank: Rank 768, slug: Slug "personaje", english: "character (in a story)", word: "personaje", example: "" }
  , { rank: Rank 769, slug: Slug "famoso", english: "famous", word: "famoso", example: "" }
  , { rank: Rank 770, slug: Slug "hambre", english: "hunger", word: "hambre", example: "" }
  , { rank: Rank 771, slug: Slug "éxito", english: "success", word: "éxito", example: "" }
  , { rank: Rank 772, slug: Slug "merecer", english: "to merit", word: "merecer", example: "" }
  , { rank: Rank 773, slug: Slug "edificio", english: "building", word: "edificio", example: "" }
  , { rank: Rank 774, slug: Slug "autoridad", english: "authority", word: "autoridad", example: "" }
  , { rank: Rank 775, slug: Slug "piedra", english: "stone", word: "piedra", example: "" }
  , { rank: Rank 776, slug: Slug "incluir", english: "to include", word: "incluir", example: "" }
  , { rank: Rank 777, slug: Slug "barco", english: "boat", word: "barco", example: "" }
  , { rank: Rank 778, slug: Slug "conjunto", english: "set", word: "conjunto", example: "" }
  , { rank: Rank 779, slug: Slug "hotel", english: "hotel", word: "hotel", example: "" }
  , { rank: Rank 780, slug: Slug "treinta", english: "thirty", word: "treinta", example: "" }
  , { rank: Rank 781, slug: Slug "inmediato", english: "immediate", word: "inmediato", example: "" }
  , { rank: Rank 782, slug: Slug "cruzar", english: "to cross", word: "cruzar", example: "" }
  , { rank: Rank 783, slug: Slug "tuyo", english: "yours", word: "tuyo", example: "" }
  , { rank: Rank 784, slug: Slug "tender", english: "to tend", word: "tender", example: "" }
  , { rank: Rank 785, slug: Slug "finalmente", english: "finally", word: "finalmente", example: "" }
  , { rank: Rank 786, slug: Slug "anunciar", english: "to advertise", word: "anunciar", example: "" }
  , { rank: Rank 787, slug: Slug "baño", english: "bath", word: "baño", example: "" }
  , { rank: Rank 788, slug: Slug "espíritu", english: "spirit", word: "espíritu", example: "" }
  , { rank: Rank 789, slug: Slug "miembro", english: "member", word: "miembro", example: "" }
  , { rank: Rank 790, slug: Slug "directo", english: "direct", word: "directo", example: "" }
  , { rank: Rank 791, slug: Slug "placer", english: "pleasure", word: "placer", example: "" }
  , { rank: Rank 792, slug: Slug "despertar", english: "to wake", word: "despertar", example: "" }
  , { rank: Rank 793, slug: Slug "recurso", english: "resource", word: "recurso", example: "" }
  , { rank: Rank 794, slug: Slug "pared", english: "wall", word: "pared", example: "" }
  , { rank: Rank 795, slug: Slug "error", english: "error", word: "error", example: "" }
  , { rank: Rank 796, slug: Slug "preciso", english: "accurate", word: "preciso", example: "" }
  , { rank: Rank 797, slug: Slug "diverso", english: "miscellaneous", word: "diverso", example: "" }
  , { rank: Rank 798, slug: Slug "dificultad", english: "difficulty", word: "dificultad", example: "" }
  , { rank: Rank 799, slug: Slug "comentar", english: "to comment", word: "comentar", example: "" }
  , { rank: Rank 800, slug: Slug "publicar", english: "to publish", word: "publicar", example: "" }
  , { rank: Rank 801, slug: Slug "familiar", english: "relating to family, a relative", word: "familiar", example: "" }
  , { rank: Rank 802, slug: Slug "voluntad", english: "will", word: "voluntad", example: "" }
  , { rank: Rank 803, slug: Slug "reunión", english: "meeting", word: "reunión", example: "" }
  , { rank: Rank 804, slug: Slug "modelo", english: "model", word: "modelo", example: "" }
  , { rank: Rank 805, slug: Slug "secreto", english: "secret", word: "secreto", example: "" }
  , { rank: Rank 806, slug: Slug "cargar", english: "to load", word: "cargar", example: "" }
  , { rank: Rank 807, slug: Slug "fecha", english: "date", word: "fecha", example: "" }
  , { rank: Rank 808, slug: Slug "participar", english: "to participate", word: "participar", example: "" }
  , { rank: Rank 809, slug: Slug "tren", english: "train", word: "tren", example: "" }
  , { rank: Rank 810, slug: Slug "impedir", english: "to prevent", word: "impedir", example: "" }
  , { rank: Rank 811, slug: Slug "propósito", english: "purpose", word: "propósito", example: "" }
  , { rank: Rank 812, slug: Slug "salvar", english: "to rescue", word: "salvar", example: "" }
  , { rank: Rank 813, slug: Slug "prisa", english: "hurry", word: "prisa", example: "" }
  , { rank: Rank 814, slug: Slug "grado", english: "degree", word: "grado", example: "" }
  , { rank: Rank 815, slug: Slug "escapar", english: "to escape", word: "escapar", example: "" }
  , { rank: Rank 816, slug: Slug "negocio", english: "deal", word: "negocio", example: "" }
  , { rank: Rank 817, slug: Slug "lucha", english: "fight", word: "lucha", example: "" }
  , { rank: Rank 818, slug: Slug "tirar", english: "to throw", word: "tirar", example: "" }
  , { rank: Rank 819, slug: Slug "entero", english: "whole", word: "entero", example: "" }
  , { rank: Rank 820, slug: Slug "interesante", english: "interesting", word: "interesante", example: "" }
  , { rank: Rank 821, slug: Slug "amplio", english: "wide", word: "amplio", example: "" }
  , { rank: Rank 822, slug: Slug "silencio", english: "silence", word: "silencio", example: "" }
  , { rank: Rank 823, slug: Slug "contestar", english: "to answer", word: "contestar", example: "" }
  , { rank: Rank 824, slug: Slug "periódico", english: "newspaper", word: "periódico", example: "" }
  , { rank: Rank 825, slug: Slug "preocupar", english: "is worrying to (to worry)", word: "preocupar", example: "" }
  , { rank: Rank 826, slug: Slug "maestro", english: "schoolteacher, master", word: "maestro", example: "" }
  , { rank: Rank 827, slug: Slug "prestar", english: "to lend", word: "prestar", example: "" }
  , { rank: Rank 828, slug: Slug "calidad", english: "quality", word: "calidad", example: "" }
  , { rank: Rank 829, slug: Slug "sal", english: "salt", word: "sal", example: "" }
  , { rank: Rank 830, slug: Slug "exponer", english: "to exhibit", word: "exponer", example: "" }
  , { rank: Rank 831, slug: Slug "control", english: "control", word: "control", example: "" }
  , { rank: Rank 832, slug: Slug "civil", english: "civil", word: "civil", example: "" }
  , { rank: Rank 833, slug: Slug "raro", english: "weird (rare)", word: "raro", example: "" }
  , { rank: Rank 834, slug: Slug "ciencia", english: "science", word: "ciencia", example: "" }
  , { rank: Rank 835, slug: Slug "tamaño", english: "size", word: "tamaño", example: "" }
  , { rank: Rank 836, slug: Slug "cuadro", english: "chart, painting", word: "cuadro", example: "" }
  , { rank: Rank 837, slug: Slug "caballo", english: "horse", word: "caballo", example: "" }
  , { rank: Rank 838, slug: Slug "responsabilidad", english: "responsibility", word: "responsabilidad", example: "" }
  , { rank: Rank 839, slug: Slug "cincuenta", english: "fifty", word: "cincuenta", example: "" }
  , { rank: Rank 840, slug: Slug "interno", english: "internal", word: "interno", example: "" }
  , { rank: Rank 841, slug: Slug "detalle", english: "detail", word: "detalle", example: "" }
  , { rank: Rank 842, slug: Slug "marcha", english: "march", word: "marcha", example: "" }
  , { rank: Rank 843, slug: Slug "nueve", english: "nine", word: "nueve", example: "" }
  , { rank: Rank 844, slug: Slug "carne", english: "meat", word: "carne", example: "" }
  , { rank: Rank 845, slug: Slug "avión", english: "plane", word: "avión", example: "" }
  , { rank: Rank 846, slug: Slug "pelo", english: "hair", word: "pelo", example: "" }
  , { rank: Rank 847, slug: Slug "pensamiento", english: "thought", word: "pensamiento", example: "" }
  , { rank: Rank 848, slug: Slug "viajar", english: "to travel", word: "viajar", example: "" }
  , { rank: Rank 849, slug: Slug "cargo", english: "charge", word: "cargo", example: "" }
  , { rank: Rank 850, slug: Slug "separar", english: "to separate", word: "separar", example: "" }
  , { rank: Rank 851, slug: Slug "construcción", english: "construction", word: "construcción", example: "" }
  , { rank: Rank 852, slug: Slug "juicio", english: "trial", word: "juicio", example: "" }
  , { rank: Rank 853, slug: Slug "terreno", english: "ground", word: "terreno", example: "" }
  , { rank: Rank 854, slug: Slug "piso", english: "floor", word: "piso", example: "" }
  , { rank: Rank 855, slug: Slug "compañia", english: "companionship, company", word: "compañía", example: "" }
  , { rank: Rank 856, slug: Slug "oro", english: "gold", word: "oro", example: "" }
  , { rank: Rank 857, slug: Slug "regresar", english: "to return", word: "regresar", example: "" }
  , { rank: Rank 858, slug: Slug "texto", english: "text", word: "texto", example: "" }
  , { rank: Rank 859, slug: Slug "fuente", english: "source", word: "fuente", example: "" }
  , { rank: Rank 860, slug: Slug "presente", english: "present", word: "presente", example: "" }
  , { rank: Rank 861, slug: Slug "oficial", english: "official", word: "oficial", example: "" }
  , { rank: Rank 862, slug: Slug "difinitivo", english: "definitive", word: "definitivo", example: "" }
  , { rank: Rank 863, slug: Slug "revista", english: "magazine", word: "revista", example: "" }
  , { rank: Rank 864, slug: Slug "daño", english: "damage", word: "daño", example: "" }
  , { rank: Rank 865, slug: Slug "esperanza", english: "hope", word: "esperanza", example: "" }
  , { rank: Rank 866, slug: Slug "máquina", english: "machine", word: "máquina", example: "" }
  , { rank: Rank 867, slug: Slug "contemplar", english: "to contemplate", word: "contemplar", example: "" }
  , { rank: Rank 868, slug: Slug "recorrer", english: "to travel through, cover", word: "recorrer", example: "" }
  , { rank: Rank 869, slug: Slug "mente", english: "mind", word: "mente", example: "" }
  , { rank: Rank 870, slug: Slug "frase", english: "phrase", word: "frase", example: "" }
  , { rank: Rank 871, slug: Slug "ejercicio", english: "exercise", word: "ejercicio", example: "" }
  , { rank: Rank 872, slug: Slug "sala", english: "hall, living room", word: "sala", example: "" }
  , { rank: Rank 873, slug: Slug "durar", english: "to last", word: "durar", example: "" }
  , { rank: Rank 874, slug: Slug "instrumento", english: "instrument", word: "instrumento", example: "" }
  , { rank: Rank 875, slug: Slug "aquello", english: "that thing", word: "aquello", example: "" }
  , { rank: Rank 876, slug: Slug "defensa", english: "defense", word: "defensa", example: "" }
  , { rank: Rank 877, slug: Slug "director", english: "director", word: "director", example: "" }
  , { rank: Rank 878, slug: Slug "retirar", english: "to withdraw", word: "retirar", example: "" }
  , { rank: Rank 879, slug: Slug "explicación", english: "explanation", word: "explicación", example: "" }
  , { rank: Rank 880, slug: Slug "artículo", english: "article", word: "artículo", example: "" }
  , { rank: Rank 881, slug: Slug "debajo", english: "underneath", word: "debajo", example: "" }
  , { rank: Rank 882, slug: Slug "permanecer", english: "to remain", word: "permanecer", example: "" }
  , { rank: Rank 883, slug: Slug "asistir", english: "to attend", word: "asistir", example: "" }
  , { rank: Rank 884, slug: Slug "doce", english: "twelve", word: "doce", example: "" }
  , { rank: Rank 885, slug: Slug "permiso", english: "permission", word: "permiso", example: "" }
  , { rank: Rank 886, slug: Slug "radio", english: "radio", word: "radio", example: "" }
  , { rank: Rank 887, slug: Slug "organizar", english: "to organize", word: "organizar", example: "" }
  , { rank: Rank 888, slug: Slug "elección", english: "choice", word: "elección", example: "" }
  , { rank: Rank 889, slug: Slug "visita", english: "visit", word: "visita", example: "" }
  , { rank: Rank 890, slug: Slug "divertido", english: "fun", word: "divertido", example: "" }
  , { rank: Rank 891, slug: Slug "contener", english: "to contain", word: "contener", example: "" }
  , { rank: Rank 892, slug: Slug "apoyo", english: "support", word: "apoyo", example: "" }
  , { rank: Rank 893, slug: Slug "árbol", english: "tree", word: "árbol", example: "" }
  , { rank: Rank 894, slug: Slug "visitar", english: "to visit", word: "visitar", example: "" }
  , { rank: Rank 895, slug: Slug "informar", english: "to report", word: "informar", example: "" }
  , { rank: Rank 896, slug: Slug "encuentro", english: "encounter", word: "encuentro", example: "" }
  , { rank: Rank 897, slug: Slug "sexo", english: "sex", word: "sexo", example: "" }
  , { rank: Rank 898, slug: Slug "parecido", english: "like", word: "parecido", example: "" }
  , { rank: Rank 899, slug: Slug "corriente", english: "ordinary, current (of water)", word: "corriente", example: "" }
  , { rank: Rank 900, slug: Slug "amable", english: "friendly", word: "amable", example: "" }
  , { rank: Rank 901, slug: Slug "lectura", english: "reading", word: "lectura", example: "" }
  , { rank: Rank 902, slug: Slug "mensaje", english: "message", word: "mensaje", example: "" }
  , { rank: Rank 903, slug: Slug "existencia", english: "existence", word: "existencia", example: "" }
  , { rank: Rank 904, slug: Slug "lenguaje", english: "language (speech, style)", word: "lenguaje", example: "" }
  , { rank: Rank 905, slug: Slug "traje", english: "costume", word: "traje", example: "" }
  , { rank: Rank 906, slug: Slug "enviar", english: "to send", word: "enviar", example: "" }
  , { rank: Rank 907, slug: Slug "alma", english: "soul", word: "alma", example: "" }
  , { rank: Rank 908, slug: Slug "aun", english: "even", word: "aun", example: "" }
  , { rank: Rank 909, slug: Slug "destino", english: "destination", word: "destino", example: "" }
  , { rank: Rank 910, slug: Slug "educación", english: "education", word: "educación", example: "" }
  , { rank: Rank 911, slug: Slug "cuidar", english: "to care", word: "cuidar", example: "" }
  , { rank: Rank 912, slug: Slug "intervenir", english: "to intervene", word: "intervenir", example: "" }
  , { rank: Rank 913, slug: Slug "cena", english: "dinner", word: "cena", example: "" }
  , { rank: Rank 914, slug: Slug "operación", english: "operation", word: "operación", example: "" }
  , { rank: Rank 915, slug: Slug "perfectamente", english: "perfectly", word: "perfectamente", example: "" }
  , { rank: Rank 916, slug: Slug "extender", english: "to extend", word: "extender", example: "" }
  , { rank: Rank 917, slug: Slug "comprobar", english: "to check", word: "comprobar", example: "" }
  , { rank: Rank 918, slug: Slug "nota", english: "note", word: "nota", example: "" }
  , { rank: Rank 919, slug: Slug "particular", english: "particular", word: "particular", example: "" }
  , { rank: Rank 920, slug: Slug "tardar", english: "to delay", word: "tardar", example: "" }
  , { rank: Rank 921, slug: Slug "adentro", english: "in, inside", word: "adentro", example: "" }
  , { rank: Rank 922, slug: Slug "militar", english: "military", word: "militar", example: "" }
  , { rank: Rank 923, slug: Slug "canción", english: "song", word: "canción", example: "" }
  , { rank: Rank 924, slug: Slug "unido", english: "attached", word: "unido", example: "" }
  , { rank: Rank 925, slug: Slug "discutir", english: "to discuss", word: "discutir", example: "" }
  , { rank: Rank 926, slug: Slug "temer", english: "to fear", word: "temer", example: "" }
  , { rank: Rank 927, slug: Slug "extraordinario", english: "extraordinary", word: "extraordinario", example: "" }
  , { rank: Rank 928, slug: Slug "teatro", english: "theater", word: "teatro", example: "" }
  , { rank: Rank 929, slug: Slug "enfrentar", english: "to face", word: "enfrentar", example: "" }
  , { rank: Rank 930, slug: Slug "recién", english: "newly, freshly", word: "recién", example: "" }
  , { rank: Rank 931, slug: Slug "media", english: "average", word: "media", example: "" }
  , { rank: Rank 932, slug: Slug "letra", english: "letter (of the alphabet)", word: "letra", example: "" }
  , { rank: Rank 933, slug: Slug "sentimiento", english: "feeling", word: "sentimiento", example: "" }
  , { rank: Rank 934, slug: Slug "conducir", english: "to drive", word: "conducir", example: "" }
  , { rank: Rank 935, slug: Slug "completamente", english: "completely", word: "completamente", example: "" }
  , { rank: Rank 936, slug: Slug "frío", english: "cold", word: "frío", example: "" }
  , { rank: Rank 937, slug: Slug "firmar", english: "to sign", word: "firmar", example: "" }
  , { rank: Rank 938, slug: Slug "solución", english: "solution", word: "solución", example: "" }
  , { rank: Rank 939, slug: Slug "salud", english: "health", word: "salud", example: "" }
  , { rank: Rank 940, slug: Slug "funciona", english: "it works", word: "funciona", example: "" }
  , { rank: Rank 941, slug: Slug "impresión", english: "print", word: "impresión", example: "" }
  , { rank: Rank 942, slug: Slug "quejarse", english: "to complain", word: "quejarse", example: "" }
  , { rank: Rank 943, slug: Slug "intención", english: "intention", word: "intención", example: "" }
  , { rank: Rank 944, slug: Slug "ritmo", english: "rate", word: "ritmo", example: "" }
  , { rank: Rank 945, slug: Slug "verde", english: "green", word: "verde", example: "" }
  , { rank: Rank 946, slug: Slug "exacto", english: "exact", word: "exacto", example: "" }
  , { rank: Rank 947, slug: Slug "respetar", english: "to respect", word: "respetar", example: "" }
  , { rank: Rank 948, slug: Slug "terrible", english: "terrible", word: "terrible", example: "" }
  , { rank: Rank 949, slug: Slug "banco", english: "bank", word: "banco", example: "" }
  , { rank: Rank 950, slug: Slug "vía", english: "via", word: "vía", example: "" }
  , { rank: Rank 951, slug: Slug "sostener", english: "to hold", word: "sostener", example: "" }
  , { rank: Rank 952, slug: Slug "luna", english: "moon", word: "luna", example: "" }
  , { rank: Rank 953, slug: Slug "piel", english: "skin", word: "piel", example: "" }
  , { rank: Rank 954, slug: Slug "izquierda", english: "left (direction)", word: "izquierda", example: "" }
  , { rank: Rank 955, slug: Slug "delante", english: "in front", word: "delante", example: "" }
  , { rank: Rank 956, slug: Slug "religioso", english: "religious", word: "religioso", example: "" }
  , { rank: Rank 957, slug: Slug "advertir", english: "to warn", word: "advertir", example: "" }
  , { rank: Rank 958, slug: Slug "oscuro", english: "dark", word: "oscuro", example: "" }
  , { rank: Rank 959, slug: Slug "investigación", english: "research", word: "investigación", example: "" }
  , { rank: Rank 960, slug: Slug "calor", english: "heat", word: "calor", example: "" }
  , { rank: Rank 961, slug: Slug "tienda", english: "shop", word: "tienda", example: "" }
  , { rank: Rank 962, slug: Slug "conversación", english: "conversation", word: "conversación", example: "" }
  , { rank: Rank 963, slug: Slug "navidad", english: "Christmas", word: "navidad", example: "" }
  , { rank: Rank 964, slug: Slug "verano", english: "summer", word: "verano", example: "" }
  , { rank: Rank 965, slug: Slug "respeto", english: "respect", word: "respeto", example: "" }
  , { rank: Rank 966, slug: Slug "abuelo", english: "grandfather", word: "abuelo", example: "" }
  , { rank: Rank 967, slug: Slug "norte", english: "north", word: "norte", example: "" }
  , { rank: Rank 968, slug: Slug "mediante", english: "by means of", word: "mediante", example: "" }
  , { rank: Rank 969, slug: Slug "tradición", english: "tradition", word: "tradición", example: "" }
  , { rank: Rank 970, slug: Slug "bastar", english: "is sufficient to (to be enough)", word: "bastar", example: "" }
  , { rank: Rank 971, slug: Slug "pareja", english: "couple", word: "pareja", example: "" }
  , { rank: Rank 972, slug: Slug "población", english: "population", word: "población", example: "" }
  , { rank: Rank 973, slug: Slug "abogado", english: "lawyer", word: "abogado", example: "" }
  , { rank: Rank 974, slug: Slug "diario", english: "daily", word: "diario", example: "" }
  , { rank: Rank 975, slug: Slug "honor", english: "honor", word: "honor", example: "" }
  , { rank: Rank 976, slug: Slug "azul", english: "blue", word: "azul", example: "" }
  , { rank: Rank 977, slug: Slug "mencionar", english: "to mention", word: "mencionar", example: "" }
  , { rank: Rank 978, slug: Slug "generación", english: "generation", word: "generación", example: "" }
  , { rank: Rank 979, slug: Slug "visión", english: "vision", word: "visión", example: "" }
  , { rank: Rank 980, slug: Slug "concreto", english: "concrete", word: "concreto", example: "" }
  , { rank: Rank 981, slug: Slug "terminado", english: "completed", word: "terminado", example: "" }
  , { rank: Rank 982, slug: Slug "plantear", english: "to raise (an issue)", word: "plantear", example: "" }
  , { rank: Rank 983, slug: Slug "dejado", english: "left behind", word: "dejado", example: "" }
  , { rank: Rank 984, slug: Slug "probar", english: "to test", word: "probar", example: "" }
  , { rank: Rank 985, slug: Slug "jurar", english: "to swear, pledge", word: "jurar", example: "" }
  , { rank: Rank 986, slug: Slug "hermoso", english: "beautiful", word: "hermoso", example: "" }
  , { rank: Rank 987, slug: Slug "peligro", english: "danger", word: "peligro", example: "" }
  , { rank: Rank 988, slug: Slug "confianza", english: "confidence", word: "confianza", example: "" }
  , { rank: Rank 989, slug: Slug "llenar", english: "to fill", word: "llenar", example: "" }
  , { rank: Rank 990, slug: Slug "sencillo", english: "simple", word: "sencillo", example: "" }
  , { rank: Rank 991, slug: Slug "mejorar", english: "to improve", word: "mejorar", example: "" }
  , { rank: Rank 992, slug: Slug "concepto", english: "concept", word: "concepto", example: "" }
  , { rank: Rank 993, slug: Slug "destacar", english: "to highlight", word: "destacar", example: "" }
  , { rank: Rank 994, slug: Slug "madera", english: "wood", word: "madera", example: "" }
  , { rank: Rank 995, slug: Slug "caminar", english: "to walk", word: "caminar", example: "" }
  , { rank: Rank 996, slug: Slug "emplear", english: "to employ", word: "emplear", example: "" }
  , { rank: Rank 997, slug: Slug "convenir", english: "to agree", word: "convenir", example: "" }
  , { rank: Rank 998, slug: Slug "energía", english: "energy", word: "energía", example: "" }
  , { rank: Rank 999, slug: Slug "admitir", english: "to admit", word: "admitir", example: "" }
  , { rank: Rank 1000, slug: Slug "encantar", english: "is delightful to (to love)", word: "encantar", example: "" }
  ]

-- | How each word is said, one entry per `IPA <tag>` column of the CSV and
-- | keyed by that tag. Empty where the deck has none.
pronunciations :: Array Dialect
pronunciations =
  [ { tag: "es-MX"
    , entries:
        [ { slug: Slug "yo", ipa: "ʝo" }
        , { slug: Slug "querer", ipa: "keˈɾeɾ" }
        , { slug: Slug "este", ipa: "ˈeste" }
        , { slug: Slug "sí", ipa: "si" }
        , { slug: Slug "no", ipa: "no" }
        , { slug: Slug "poder", ipa: "poˈdeɾ" }
        , { slug: Slug "hablar", ipa: "aˈblaɾ" }
        , { slug: Slug "encontrar", ipa: "enkonˈtɾaɾ" }
        , { slug: Slug "tener", ipa: "teˈneɾ" }
        , { slug: Slug "necesitar", ipa: "nesesiˈtaɾ" }
        , { slug: Slug "donde", ipa: "ˈdonde" }
        , { slug: Slug "que", ipa: "ke" }
        , { slug: Slug "el / la", ipa: "el / la" }
        , { slug: Slug "lugar", ipa: "luˈɡaɾ" }
        , { slug: Slug "casa", ipa: "ˈkasa" }
        , { slug: Slug "algo", ipa: "ˈalɡo" }
        , { slug: Slug "ese", ipa: "ˈese" }
        , { slug: Slug "y", ipa: "i" }
        , { slug: Slug "ver", ipa: "beɾ" }
        , { slug: Slug "pero", ipa: "ˈpeɾo" }
        , { slug: Slug "ir(se)", ipa: "iɾ(se)" }
        , { slug: Slug "a", ipa: "a" }
        , { slug: Slug "decir", ipa: "deˈsiɾ" }
        , { slug: Slug "o", ipa: "o" }
        , { slug: Slug "un", ipa: "un" }
        , { slug: Slug "más", ipa: "mas" }
        , { slug: Slug "como", ipa: "ˈkomo" }
        , { slug: Slug "se", ipa: "se" }
        , { slug: Slug "venir", ipa: "beˈniɾ" }
        , { slug: Slug "mi", ipa: "mi" }
        , { slug: Slug "ser", ipa: "seɾ" }
        , { slug: Slug "estar", ipa: "esˈtaɾ" }
        , { slug: Slug "vivir", ipa: "biˈbiɾ" }
        , { slug: Slug "pasar", ipa: "paˈsaɾ" }
        , { slug: Slug "día", ipa: "ˈdia" }
        , { slug: Slug "año", ipa: "ˈaɲo" }
        , { slug: Slug "semana", ipa: "seˈmana" }
        , { slug: Slug "mes", ipa: "mes" }
        , { slug: Slug "cada", ipa: "ˈkada" }
        , { slug: Slug "tiempo", ipa: "ˈtjempo" }
        , { slug: Slug "saber", ipa: "saˈbeɾ" }
        , { slug: Slug "conocer", ipa: "konoˈseɾ" }
        , { slug: Slug "hacer", ipa: "aˈseɾ" }
        , { slug: Slug "practicar", ipa: "pɾaktiˈkaɾ" }
        , { slug: Slug "llegar", ipa: "ʝeˈɡaɾ" }
        , { slug: Slug "también", ipa: "tamˈbjen" }
        , { slug: Slug "cuando", ipa: "ˈkwando" }
        , { slug: Slug "hasta", ipa: "ˈasta" }
        , { slug: Slug "mañana", ipa: "maˈɲana" }
        , { slug: Slug "él / ella", ipa: "el / ˈeʝa" }
        , { slug: Slug "gustar", ipa: "ɡusˈtaɾ" }
        , { slug: Slug "me", ipa: "me" }
        , { slug: Slug "te", ipa: "te" }
        , { slug: Slug "le", ipa: "le" }
        , { slug: Slug "nos", ipa: "nos" }
        , { slug: Slug "les", ipa: "les" }
        , { slug: Slug "amigo", ipa: "aˈmiɡo" }
        , { slug: Slug "comida", ipa: "koˈmida" }
        , { slug: Slug "otro", ipa: "ˈotɾo" }
        , { slug: Slug "trabajo", ipa: "tɾaˈbaxo" }
        , { slug: Slug "por", ipa: "poɾ" }
        , { slug: Slug "para", ipa: "ˈpaɾa" }
        , { slug: Slug "ejemplo", ipa: "eˈxemplo" }
        , { slug: Slug "de", ipa: "de" }
        , { slug: Slug "en", ipa: "en" }
        , { slug: Slug "con", ipa: "kon" }
        , { slug: Slug "dar", ipa: "daɾ" }
        , { slug: Slug "país", ipa: "paˈis" }
        , { slug: Slug "hombre", ipa: "ˈombɾe" }
        , { slug: Slug "mujer", ipa: "muˈxeɾ" }
        , { slug: Slug "haber", ipa: "aˈbeɾ" }
        , { slug: Slug "muy", ipa: "mwi" }
        , { slug: Slug "mucho", ipa: "ˈmutʃo" }
        , { slug: Slug "grande", ipa: "ˈɡɾande" }
        , { slug: Slug "menos", ipa: "ˈmenos" }
        , { slug: Slug "poco", ipa: "ˈpoko" }
        , { slug: Slug "cosa", ipa: "ˈkosa" }
        , { slug: Slug "si", ipa: "si" }
        , { slug: Slug "nuestro", ipa: "ˈnwestɾo" }
        , { slug: Slug "siempre", ipa: "ˈsjempɾe" }
        , { slug: Slug "vida", ipa: "ˈbida" }
        , { slug: Slug "después", ipa: "desˈpwes" }
        , { slug: Slug "entonces", ipa: "enˈtonses" }
        , { slug: Slug "poner", ipa: "poˈneɾ" }
        , { slug: Slug "deber", ipa: "deˈbeɾ" }
        , { slug: Slug "bien", ipa: "bjen" }
        , { slug: Slug "entre", ipa: "ˈentɾe" }
        , { slug: Slug "palabra", ipa: "paˈlabɾa" }
        , { slug: Slug "ahora", ipa: "aˈoɾa" }
        , { slug: Slug "aprender", ipa: "apɾenˈdeɾ" }
        , { slug: Slug "tu", ipa: "tu" }
        , { slug: Slug "creer", ipa: "kɾeˈeɾ" }
        , { slug: Slug "parecer", ipa: "paɾeˈseɾ" }
        , { slug: Slug "nada", ipa: "ˈnada" }
        , { slug: Slug "todo", ipa: "ˈtodo" }
        , { slug: Slug "porque", ipa: "ˈpoɾke" }
        , { slug: Slug "ayudar", ipa: "aʝuˈdaɾ" }
        , { slug: Slug "pedir", ipa: "peˈdiɾ" }
        , { slug: Slug "preguntar", ipa: "pɾeɡunˈtaɾ" }
        , { slug: Slug "qué", ipa: "ke" }
        , { slug: Slug "lo", ipa: "lo" }
        , { slug: Slug "su", ipa: "su" }
        , { slug: Slug "aquí", ipa: "aˈki" }
        , { slug: Slug "ya", ipa: "ʝa" }
        , { slug: Slug "sin", ipa: "sin" }
        , { slug: Slug "vez", ipa: "bes" }
        , { slug: Slug "hay", ipa: "aj" }
        , { slug: Slug "sobre", ipa: "ˈsobɾe" }
        , { slug: Slug "tú", ipa: "tu" }
        , { slug: Slug "alguno", ipa: "alˈɡuno" }
        , { slug: Slug "mismo", ipa: "ˈmismo" }
        , { slug: Slug "así", ipa: "aˈsi" }
        , { slug: Slug "cómo", ipa: "ˈkomo" }
        , { slug: Slug "dos", ipa: "dos" }
        , { slug: Slug "sólo", ipa: "ˈsolo" }
        , { slug: Slug "primero", ipa: "pɾiˈmeɾo" }
        , { slug: Slug "desde", ipa: "ˈdesde" }
        , { slug: Slug "ni", ipa: "ni" }
        , { slug: Slug "gracias", ipa: "ˈɡɾasjas" }
        , { slug: Slug "bueno", ipa: "ˈbweno" }
        , { slug: Slug "uno", ipa: "ˈuno" }
        , { slug: Slug "usted", ipa: "usˈted" }
        , { slug: Slug "tanto", ipa: "ˈtanto" }
        , { slug: Slug "señor", ipa: "seˈɲoɾ" }
        , { slug: Slug "tan", ipa: "tan" }
        , { slug: Slug "quién", ipa: "kjen" }
        , { slug: Slug "parte", ipa: "ˈpaɾte" }
        , { slug: Slug "quedar", ipa: "keˈdaɾ" }
        , { slug: Slug "por favor", ipa: "poɾ faˈboɾ" }
        , { slug: Slug "dónde", ipa: "ˈdonde" }
        , { slug: Slug "nunca", ipa: "ˈnunka" }
        , { slug: Slug "llevar", ipa: "ʝeˈbaɾ" }
        , { slug: Slug "dejar", ipa: "deˈxaɾ" }
        , { slug: Slug "verdad", ipa: "beɾˈdad" }
        , { slug: Slug "seguir", ipa: "seˈɡiɾ" }
        , { slug: Slug "nuevo", ipa: "ˈnwebo" }
        , { slug: Slug "pues", ipa: "pwes" }
        , { slug: Slug "llamar(se)", ipa: "ʝaˈmaɾ(se)" }
        , { slug: Slug "mejor", ipa: "meˈxoɾ" }
        , { slug: Slug "pensar", ipa: "penˈsaɾ" }
        , { slug: Slug "aquel", ipa: "aˈkel" }
        , { slug: Slug "momento", ipa: "moˈmento" }
        , { slug: Slug "dios", ipa: "djos" }
        , { slug: Slug "sino", ipa: "ˈsino" }
        , { slug: Slug "salir", ipa: "saˈliɾ" }
        , { slug: Slug "volver", ipa: "bolˈbeɾ" }
        , { slug: Slug "forma", ipa: "ˈfoɾma" }
        , { slug: Slug "antes", ipa: "ˈantes" }
        , { slug: Slug "aunque", ipa: "ˈawnke" }
        , { slug: Slug "mundo", ipa: "ˈmundo" }
        , { slug: Slug "tres", ipa: "tɾes" }
        , { slug: Slug "tal", ipa: "tal" }
        , { slug: Slug "ahí", ipa: "aˈi" }
        , { slug: Slug "tomar", ipa: "toˈmaɾ" }
        , { slug: Slug "cierto", ipa: "ˈsjeɾto" }
        , { slug: Slug "hacia", ipa: "ˈasja" }
        , { slug: Slug "caso", ipa: "ˈkaso" }
        , { slug: Slug "noche", ipa: "ˈnotʃe" }
        , { slug: Slug "sentir", ipa: "senˈtiɾ" }
        , { slug: Slug "luego", ipa: "ˈlweɡo" }
        , { slug: Slug "alguien", ipa: "ˈalɡjen" }
        , { slug: Slug "tratar", ipa: "tɾaˈtaɾ" }
        , { slug: Slug "persona", ipa: "peɾˈsona" }
        , { slug: Slug "mayor", ipa: "maˈʝoɾ" }
        , { slug: Slug "último", ipa: "ˈultimo" }
        , { slug: Slug "solo", ipa: "ˈsolo" }
        , { slug: Slug "propio", ipa: "ˈpɾopjo" }
        , { slug: Slug "nadie", ipa: "ˈnadje" }
        , { slug: Slug "quien", ipa: "kjen" }
        , { slug: Slug "nosotros", ipa: "noˈsotɾos" }
        , { slug: Slug "mirar", ipa: "miˈɾaɾ" }
        , { slug: Slug "padre", ipa: "ˈpadɾe" }
        , { slug: Slug "hora", ipa: "ˈoɾa" }
        , { slug: Slug "gente", ipa: "ˈxente" }
        , { slug: Slug "ninguno", ipa: "ninˈɡuno" }
        , { slug: Slug "dinero", ipa: "diˈneɾo" }
        , { slug: Slug "casi", ipa: "ˈkasi" }
        , { slug: Slug "punto", ipa: "ˈpunto" }
        , { slug: Slug "hecho", ipa: "ˈetʃo" }
        , { slug: Slug "durante", ipa: "duˈɾante" }
        , { slug: Slug "cualquier", ipa: "kwalˈkjeɾ" }
        , { slug: Slug "mano", ipa: "ˈmano" }
        , { slug: Slug "manera", ipa: "maˈneɾa" }
        , { slug: Slug "cual", ipa: "kwal" }
        , { slug: Slug "mientras", ipa: "ˈmjentɾas" }
        , { slug: Slug "contar", ipa: "konˈtaɾ" }
        , { slug: Slug "fin", ipa: "fin" }
        , { slug: Slug "tipo", ipa: "ˈtipo" }
        , { slug: Slug "claro", ipa: "ˈklaɾo" }
        , { slug: Slug "además", ipa: "adeˈmas" }
        , { slug: Slug "empezar", ipa: "empeˈsaɾ" }
        , { slug: Slug "esperar", ipa: "espeˈɾaɾ" }
        , { slug: Slug "hoy", ipa: "oj" }
        , { slug: Slug "lado", ipa: "ˈlado" }
        , { slug: Slug "hijo", ipa: "ˈixo" }
        , { slug: Slug "allí", ipa: "aˈʝi" }
        , { slug: Slug "éste", ipa: "ˈeste" }
        , { slug: Slug "problema", ipa: "pɾoˈblema" }
        , { slug: Slug "acuerdo", ipa: "aˈkweɾdo" }
        , { slug: Slug "cuenta", ipa: "ˈkwenta" }
        , { slug: Slug "medio", ipa: "ˈmedjo" }
        , { slug: Slug "contra", ipa: "ˈkontɾa" }
        , { slug: Slug "fuera", ipa: "ˈfweɾa" }
        , { slug: Slug "buscar", ipa: "busˈkaɾ" }
        , { slug: Slug "dentro", ipa: "ˈdentɾo" }
        , { slug: Slug "largo", ipa: "ˈlaɾɡo" }
        , { slug: Slug "seguro", ipa: "seˈɡuɾo" }
        , { slug: Slug "existir", ipa: "eksisˈtiɾ" }
        , { slug: Slug "niño", ipa: "ˈniɲo" }
        , { slug: Slug "entrar", ipa: "enˈtɾaɾ" }
        , { slug: Slug "madre", ipa: "ˈmadɾe" }
        , { slug: Slug "sin embargo", ipa: "sin emˈbaɾɡo" }
        , { slug: Slug "único", ipa: "ˈuniko" }
        , { slug: Slug "trabajar", ipa: "tɾabaˈxaɾ" }
        , { slug: Slug "pequeño", ipa: "peˈkeɲo" }
        , { slug: Slug "alto", ipa: "ˈalto" }
        , { slug: Slug "cambio", ipa: "ˈkambjo" }
        , { slug: Slug "escribir", ipa: "eskɾiˈbiɾ" }
        , { slug: Slug "cuatro", ipa: "ˈkwatɾo" }
        , { slug: Slug "perder", ipa: "peɾˈdeɾ" }
        , { slug: Slug "historia", ipa: "isˈtoɾja" }
        , { slug: Slug "espera", ipa: "esˈpeɾa" }
        , { slug: Slug "idea", ipa: "iˈdea" }
        , { slug: Slug "agua", ipa: "ˈaɡwa" }
        , { slug: Slug "producir", ipa: "pɾoduˈsiɾ" }
        , { slug: Slug "ciudad", ipa: "sjuˈdad" }
        , { slug: Slug "estado", ipa: "esˈtado" }
        , { slug: Slug "modo", ipa: "ˈmodo" }
        , { slug: Slug "nombre", ipa: "ˈnombɾe" }
        , { slug: Slug "ocurrir", ipa: "okuˈriɾ" }
        , { slug: Slug "familia", ipa: "faˈmilja" }
        , { slug: Slug "realidad", ipa: "realiˈdad" }
        , { slug: Slug "entender", ipa: "entenˈdeɾ" }
        , { slug: Slug "recibir", ipa: "resiˈbiɾ" }
        , { slug: Slug "obra", ipa: "ˈobɾa" }
        , { slug: Slug "importante", ipa: "impoɾˈtante" }
        , { slug: Slug "conmigo", ipa: "konˈmiɡo" }
        , { slug: Slug "mal", ipa: "mal" }
        , { slug: Slug "todavía", ipa: "todaˈbia" }
        , { slug: Slug "razón", ipa: "raˈson" }
        , { slug: Slug "cuanto", ipa: "ˈkwanto" }
        , { slug: Slug "bajo", ipa: "ˈbaxo" }
        , { slug: Slug "recordar", ipa: "rekoɾˈdaɾ" }
        , { slug: Slug "grupo", ipa: "ˈɡɾupo" }
        , { slug: Slug "amor", ipa: "aˈmoɾ" }
        , { slug: Slug "mil", ipa: "mil" }
        , { slug: Slug "mío", ipa: "ˈmio" }
        , { slug: Slug "humano", ipa: "uˈmano" }
        , { slug: Slug "terminar", ipa: "teɾmiˈnaɾ" }
        , { slug: Slug "permitir", ipa: "peɾmiˈtiɾ" }
        , { slug: Slug "aparecer", ipa: "apaɾeˈseɾ" }
        , { slug: Slug "conseguir", ipa: "konseˈɡiɾ" }
        , { slug: Slug "tarde", ipa: "ˈtaɾde" }
        , { slug: Slug "comenzar", ipa: "komenˈsaɾ" }
        , { slug: Slug "varios", ipa: "ˈbaɾjos" }
        , { slug: Slug "posible", ipa: "poˈsible" }
        , { slug: Slug "aún", ipa: "aˈun" }
        , { slug: Slug "servir", ipa: "seɾˈbiɾ" }
        , { slug: Slug "general", ipa: "xeneˈɾal" }
        , { slug: Slug "sacar", ipa: "saˈkaɾ" }
        , { slug: Slug "relación", ipa: "relaˈsjon" }
        , { slug: Slug "cinco", ipa: "ˈsinko" }
        , { slug: Slug "cuerpo", ipa: "ˈkweɾpo" }
        , { slug: Slug "contigo", ipa: "konˈtiɡo" }
        , { slug: Slug "mantener", ipa: "manteˈneɾ" }
        , { slug: Slug "ante", ipa: "ˈante" }
        , { slug: Slug "principio", ipa: "pɾinˈsipjo" }
        , { slug: Slug "resultar", ipa: "resulˈtaɾ" }
        , { slug: Slug "igual", ipa: "iˈɡwal" }
        , { slug: Slug "demasiado", ipa: "demaˈsjado" }
        , { slug: Slug "pueblo", ipa: "ˈpweblo" }
        , { slug: Slug "segundo", ipa: "seˈɡundo" }
        , { slug: Slug "leer", ipa: "leˈeɾ" }
        , { slug: Slug "caer", ipa: "kaˈeɾ" }
        , { slug: Slug "cambiar", ipa: "kamˈbjaɾ" }
        , { slug: Slug "ojo", ipa: "ˈoxo" }
        , { slug: Slug "adiós", ipa: "aˈdjos" }
        , { slug: Slug "calle", ipa: "ˈkaʝe" }
        , { slug: Slug "presentar", ipa: "pɾesenˈtaɾ" }
        , { slug: Slug "blanco", ipa: "ˈblanko" }
        , { slug: Slug "crear", ipa: "kɾeˈaɾ" }
        , { slug: Slug "abrir", ipa: "aˈbɾiɾ" }
        , { slug: Slug "libro", ipa: "ˈlibɾo" }
        , { slug: Slug "distinto", ipa: "disˈtinto" }
        , { slug: Slug "fuerza", ipa: "ˈfweɾsa" }
        , { slug: Slug "luz", ipa: "lus" }
        , { slug: Slug "según", ipa: "seˈɡun" }
        , { slug: Slug "santo", ipa: "ˈsanto" }
        , { slug: Slug "frente", ipa: "ˈfɾente" }
        , { slug: Slug "considerar", ipa: "konsideˈɾaɾ" }
        , { slug: Slug "realmente", ipa: "realˈmente" }
        , { slug: Slug "policía", ipa: "poliˈsia" }
        , { slug: Slug "oír", ipa: "oˈiɾ" }
        , { slug: Slug "cuyo", ipa: "ˈkuʝo" }
        , { slug: Slug "sentido", ipa: "senˈtido" }
        , { slug: Slug "acabar", ipa: "akaˈbaɾ" }
        , { slug: Slug "paso", ipa: "ˈpaso" }
        , { slug: Slug "situación", ipa: "sitwaˈsjon" }
        , { slug: Slug "serio", ipa: "ˈseɾjo" }
        , { slug: Slug "cabeza", ipa: "kaˈbesa" }
        , { slug: Slug "bastante", ipa: "basˈtante" }
        , { slug: Slug "hermano", ipa: "eɾˈmano" }
        , { slug: Slug "convertir", ipa: "konbeɾˈtiɾ" }
        , { slug: Slug "gracia", ipa: "ˈɡɾasja" }
        , { slug: Slug "siglo", ipa: "ˈsiɡlo" }
        , { slug: Slug "pasado", ipa: "paˈsado" }
        , { slug: Slug "malo", ipa: "ˈmalo" }
        , { slug: Slug "tierra", ipa: "ˈtjera" }
        , { slug: Slug "papel", ipa: "paˈpel" }
        , { slug: Slug "cariño", ipa: "kaˈɾiɲo" }
        , { slug: Slug "vale", ipa: "ˈbale" }
        , { slug: Slug "tampoco", ipa: "tamˈpoko" }
        , { slug: Slug "social", ipa: "soˈsjal" }
        , { slug: Slug "viejo", ipa: "ˈbjexo" }
        , { slug: Slug "señora", ipa: "seˈɲoɾa" }
        , { slug: Slug "tema", ipa: "ˈtema" }
        , { slug: Slug "político", ipa: "poˈlitiko" }
        , { slug: Slug "Español", ipa: "espaˈɲol" }
        , { slug: Slug "muerto", ipa: "ˈmweɾto" }
        , { slug: Slug "ganar", ipa: "ɡaˈnaɾ" }
        , { slug: Slug "formar", ipa: "foɾˈmaɾ" }
        , { slug: Slug "clase", ipa: "ˈklase" }
        , { slug: Slug "rápido", ipa: "ˈrapido" }
        , { slug: Slug "traer", ipa: "tɾaˈeɾ" }
        , { slug: Slug "partir", ipa: "paɾˈtiɾ" }
        , { slug: Slug "morir", ipa: "moˈɾiɾ" }
        , { slug: Slug "incluso", ipa: "inˈkluso" }
        , { slug: Slug "suerte", ipa: "ˈsweɾte" }
        , { slug: Slug "campo", ipa: "ˈkampo" }
        , { slug: Slug "cuidado", ipa: "kwiˈdado" }
        , { slug: Slug "aceptar", ipa: "asepˈtaɾ" }
        , { slug: Slug "quizás", ipa: "kiˈsas" }
        , { slug: Slug "realizar", ipa: "realiˈsaɾ" }
        , { slug: Slug "ciento", ipa: "ˈsjento" }
        , { slug: Slug "miedo", ipa: "ˈmjedo" }
        , { slug: Slug "orden", ipa: "ˈoɾden" }
        , { slug: Slug "puerta", ipa: "ˈpweɾta" }
        , { slug: Slug "pronto", ipa: "ˈpɾonto" }
        , { slug: Slug "suponer", ipa: "supoˈneɾ" }
        , { slug: Slug "comprender", ipa: "kompɾenˈdeɾ" }
        , { slug: Slug "final", ipa: "fiˈnal" }
        , { slug: Slug "interés", ipa: "inteˈɾes" }
        , { slug: Slug "siguiente", ipa: "siˈɡjente" }
        , { slug: Slug "vista", ipa: "ˈbista" }
        , { slug: Slug "lograr", ipa: "loˈɡɾaɾ" }
        , { slug: Slug "demás", ipa: "deˈmas" }
        , { slug: Slug "os", ipa: "os" }
        , { slug: Slug "chico", ipa: "ˈtʃiko" }
        , { slug: Slug "difícil", ipa: "diˈfisil" }
        , { slug: Slug "cuánto", ipa: "ˈkwanto" }
        , { slug: Slug "número", ipa: "ˈnumeɾo" }
        , { slug: Slug "explicar", ipa: "ekspliˈkaɾ" }
        , { slug: Slug "venga", ipa: "ˈbenɡa" }
        , { slug: Slug "negro", ipa: "ˈneɡɾo" }
        , { slug: Slug "camino", ipa: "kaˈmino" }
        , { slug: Slug "fondo", ipa: "ˈfondo" }
        , { slug: Slug "voz", ipa: "bos" }
        , { slug: Slug "estudio", ipa: "esˈtudjo" }
        , { slug: Slug "necesario", ipa: "neseˈsaɾjo" }
        , { slug: Slug "allá", ipa: "aˈʝa" }
        , { slug: Slug "tocar", ipa: "toˈkaɾ" }
        , { slug: Slug "valor", ipa: "baˈloɾ" }
        , { slug: Slug "reconocer", ipa: "rekonoˈseɾ" }
        , { slug: Slug "estudiar", ipa: "estuˈdjaɾ" }
        , { slug: Slug "alcanzar", ipa: "alkanˈsaɾ" }
        , { slug: Slug "nacer", ipa: "naˈseɾ" }
        , { slug: Slug "dirigir", ipa: "diɾiˈxiɾ" }
        , { slug: Slug "correr", ipa: "koˈreɾ" }
        , { slug: Slug "feliz", ipa: "feˈlis" }
        , { slug: Slug "medida", ipa: "meˈdida" }
        , { slug: Slug "menor", ipa: "meˈnoɾ" }
        , { slug: Slug "guerra", ipa: "ˈɡera" }
        , { slug: Slug "solamente", ipa: "solaˈmente" }
        , { slug: Slug "esposa", ipa: "esˈposa" }
        , { slug: Slug "utilizar", ipa: "utiliˈsaɾ" }
        , { slug: Slug "adelante", ipa: "adeˈlante" }
        , { slug: Slug "centro", ipa: "ˈsentɾo" }
        , { slug: Slug "cuál", ipa: "kwal" }
        , { slug: Slug "necesidad", ipa: "nesesiˈdad" }
        , { slug: Slug "condición", ipa: "kondiˈsjon" }
        , { slug: Slug "pagar", ipa: "paˈɡaɾ" }
        , { slug: Slug "ello", ipa: "ˈeʝo" }
        , { slug: Slug "falta", ipa: "ˈfalta" }
        , { slug: Slug "muerte", ipa: "ˈmweɾte" }
        , { slug: Slug "diez", ipa: "djes" }
        , { slug: Slug "través", ipa: "tɾaˈbes" }
        , { slug: Slug "antiguo", ipa: "anˈtiɡwo" }
        , { slug: Slug "supuesto", ipa: "suˈpwesto" }
        , { slug: Slug "edad", ipa: "eˈdad" }
        , { slug: Slug "jugar", ipa: "xuˈɡaɾ" }
        , { slug: Slug "corazón", ipa: "koɾaˈson" }
        , { slug: Slug "cara", ipa: "ˈkaɾa" }
        , { slug: Slug "jefe", ipa: "ˈxefe" }
        , { slug: Slug "época", ipa: "ˈepoka" }
        , { slug: Slug "color", ipa: "koˈloɾ" }
        , { slug: Slug "escuchar", ipa: "eskuˈtʃaɾ" }
        , { slug: Slug "ayuda", ipa: "aˈʝuda" }
        , { slug: Slug "experiencia", ipa: "ekspeˈɾjensja" }
        , { slug: Slug "movimiento", ipa: "mobiˈmjento" }
        , { slug: Slug "cumplir", ipa: "kumˈpliɾ" }
        , { slug: Slug "especial", ipa: "espeˈsjal" }
        , { slug: Slug "diferente", ipa: "difeˈɾente" }
        , { slug: Slug "pesar", ipa: "peˈsaɾ" }
        , { slug: Slug "posibilidad", ipa: "posibiliˈdad" }
        , { slug: Slug "ofrecer", ipa: "ofɾeˈseɾ" }
        , { slug: Slug "arriba", ipa: "aˈriba" }
        , { slug: Slug "descubrir", ipa: "deskuˈbɾiɾ" }
        , { slug: Slug "hija", ipa: "ˈixa" }
        , { slug: Slug "anterior", ipa: "anteˈɾjoɾ" }
        , { slug: Slug "juego", ipa: "ˈxweɡo" }
        , { slug: Slug "levantar(se)", ipa: "lebanˈtaɾ(se)" }
        , { slug: Slug "pobre", ipa: "ˈpobɾe" }
        , { slug: Slug "aire", ipa: "ˈajɾe" }
        , { slug: Slug "seis", ipa: "sejs" }
        , { slug: Slug "intentar", ipa: "intenˈtaɾ" }
        , { slug: Slug "junto", ipa: "ˈxunto" }
        , { slug: Slug "resultado", ipa: "resulˈtado" }
        , { slug: Slug "usar", ipa: "uˈsaɾ" }
        , { slug: Slug "decidir", ipa: "desiˈdiɾ" }
        , { slug: Slug "repetir", ipa: "repeˈtiɾ" }
        , { slug: Slug "olvidar", ipa: "olbiˈdaɾ" }
        , { slug: Slug "ley", ipa: "lej" }
        , { slug: Slug "aspecto", ipa: "asˈpekto" }
        , { slug: Slug "pie", ipa: "pje" }
        , { slug: Slug "valer", ipa: "baˈleɾ" }
        , { slug: Slug "especie", ipa: "esˈpesje" }
        , { slug: Slug "comer", ipa: "koˈmeɾ" }
        , { slug: Slug "servicio", ipa: "seɾˈbisjo" }
        , { slug: Slug "cerca", ipa: "ˈseɾka" }
        , { slug: Slug "mostrar", ipa: "mosˈtɾaɾ" }
        , { slug: Slug "actividad", ipa: "aktibiˈdad" }
        , { slug: Slug "tercero", ipa: "teɾˈseɾo" }
        , { slug: Slug "tío", ipa: "ˈtio" }
        , { slug: Slug "ocupar", ipa: "okuˈpaɾ" }
        , { slug: Slug "cuestión", ipa: "kwesˈtjon" }
        , { slug: Slug "duda", ipa: "ˈduda" }
        , { slug: Slug "siquiera", ipa: "siˈkjeɾa" }
        , { slug: Slug "diferencia", ipa: "difeˈɾensja" }
        , { slug: Slug "mover", ipa: "moˈbeɾ" }
        , { slug: Slug "continuar", ipa: "kontiˈnwaɾ" }
        , { slug: Slug "cantidad", ipa: "kantiˈdad" }
        , { slug: Slug "acción", ipa: "akˈsjon" }
        , { slug: Slug "suceder", ipa: "suseˈdeɾ" }
        , { slug: Slug "fijar", ipa: "fiˈxaɾ" }
        , { slug: Slug "sociedad", ipa: "sosjeˈdad" }
        , { slug: Slug "referir", ipa: "refeˈɾiɾ" }
        , { slug: Slug "acercar", ipa: "aseɾˈkaɾ" }
        , { slug: Slug "capaz", ipa: "kaˈpas" }
        , { slug: Slug "libre", ipa: "ˈlibɾe" }
        , { slug: Slug "natural", ipa: "natuˈɾal" }
        , { slug: Slug "dedicar", ipa: "dediˈkaɾ" }
        , { slug: Slug "peso", ipa: "ˈpeso" }
        , { slug: Slug "efecto", ipa: "eˈfekto" }
        , { slug: Slug "objeto", ipa: "obˈxeto" }
        , { slug: Slug "doctor", ipa: "dokˈtoɾ" }
        , { slug: Slug "verdadero", ipa: "beɾdaˈdeɾo" }
        , { slug: Slug "suficiente", ipa: "sufiˈsjente" }
        , { slug: Slug "joven", ipa: "ˈxoben" }
        , { slug: Slug "partido", ipa: "paɾˈtido" }
        , { slug: Slug "económico", ipa: "ekoˈnomiko" }
        , { slug: Slug "abajo", ipa: "aˈbaxo" }
        , { slug: Slug "derecho", ipa: "deˈɾetʃo" }
        , { slug: Slug "primer", ipa: "pɾiˈmeɾ" }
        , { slug: Slug "importancia", ipa: "impoɾˈtansja" }
        , { slug: Slug "genial", ipa: "xeˈnjal" }
        , { slug: Slug "sistema", ipa: "sisˈtema" }
        , { slug: Slug "justo", ipa: "ˈxusto" }
        , { slug: Slug "viaje", ipa: "ˈbjaxe" }
        , { slug: Slug "suelo", ipa: "ˈswelo" }
        , { slug: Slug "respecto", ipa: "resˈpekto" }
        , { slug: Slug "conocimiento", ipa: "konosiˈmjento" }
        , { slug: Slug "libertad", ipa: "libeɾˈtad" }
        , { slug: Slug "encima", ipa: "enˈsima" }
        , { slug: Slug "comprar", ipa: "komˈpɾaɾ" }
        , { slug: Slug "común", ipa: "koˈmun" }
        , { slug: Slug "abierto", ipa: "aˈbjeɾto" }
        , { slug: Slug "próximo", ipa: "ˈpɾoksimo" }
        , { slug: Slug "fuerte", ipa: "ˈfweɾte" }
        , { slug: Slug "atención", ipa: "atenˈsjon" }
        , { slug: Slug "subir", ipa: "suˈbiɾ" }
        , { slug: Slug "esfuerzo", ipa: "esˈfweɾso" }
        , { slug: Slug "evitar", ipa: "ebiˈtaɾ" }
        , { slug: Slug "resto", ipa: "ˈresto" }
        , { slug: Slug "interesar", ipa: "inteɾeˈsaɾ" }
        , { slug: Slug "atrás", ipa: "aˈtɾas" }
        , { slug: Slug "zona", ipa: "ˈsona" }
        , { slug: Slug "proceso", ipa: "pɾoˈseso" }
        , { slug: Slug "vivo", ipa: "ˈbibo" }
        , { slug: Slug "cerrar", ipa: "seˈraɾ" }
        , { slug: Slug "vino", ipa: "ˈbino" }
        , { slug: Slug "echar", ipa: "eˈtʃaɾ" }
        , { slug: Slug "responder", ipa: "responˈdeɾ" }
        , { slug: Slug "sufrir", ipa: "suˈfɾiɾ" }
        , { slug: Slug "completo", ipa: "komˈpleto" }
        , { slug: Slug "minuto", ipa: "miˈnuto" }
        , { slug: Slug "escuela", ipa: "esˈkwela" }
        , { slug: Slug "contrario", ipa: "konˈtɾaɾjo" }
        , { slug: Slug "mesa", ipa: "ˈmesa" }
        , { slug: Slug "real", ipa: "reˈal" }
        , { slug: Slug "ocasión", ipa: "okaˈsjon" }
        , { slug: Slug "sangre", ipa: "ˈsanɡɾe" }
        , { slug: Slug "importar", ipa: "impoɾˈtaɾ" }
        , { slug: Slug "público", ipa: "ˈpubliko" }
        , { slug: Slug "coche", ipa: "ˈkotʃe" }
        , { slug: Slug "obtener", ipa: "obteˈneɾ" }
        , { slug: Slug "programa", ipa: "pɾoˈɡɾama" }
        , { slug: Slug "lejos", ipa: "ˈlexos" }
        , { slug: Slug "siete", ipa: "ˈsjete" }
        , { slug: Slug "enorme", ipa: "eˈnoɾme" }
        , { slug: Slug "respuesta", ipa: "resˈpwesta" }
        , { slug: Slug "línea", ipa: "ˈlinea" }
        , { slug: Slug "espacio", ipa: "esˈpasjo" }
        , { slug: Slug "nivel", ipa: "niˈbel" }
        , { slug: Slug "paz", ipa: "pas" }
        , { slug: Slug "gobierno", ipa: "ɡoˈbjeɾno" }
        , { slug: Slug "cabo", ipa: "ˈkabo" }
        , { slug: Slug "vuelta", ipa: "ˈbwelta" }
        , { slug: Slug "observar", ipa: "obseɾˈbaɾ" }
        , { slug: Slug "indicar", ipa: "indiˈkaɾ" }
        , { slug: Slug "pregunta", ipa: "pɾeˈɡunta" }
        , { slug: Slug "imagen", ipa: "iˈmaxen" }
        , { slug: Slug "carrera", ipa: "kaˈreɾa" }
        , { slug: Slug "culpa", ipa: "ˈkulpa" }
        , { slug: Slug "imaginar", ipa: "imaxiˈnaɾ" }
        , { slug: Slug "soler", ipa: "soˈleɾ" }
        , { slug: Slug "ambos", ipa: "ˈambos" }
        , { slug: Slug "acompañar", ipa: "akompaˈɲaɾ" }
        , { slug: Slug "profundo", ipa: "pɾoˈfundo" }
        , { slug: Slug "detener", ipa: "deteˈneɾ" }
        , { slug: Slug "desarrollar", ipa: "desaroˈʝaɾ" }
        , { slug: Slug "ocho", ipa: "ˈotʃo" }
        , { slug: Slug "fácil", ipa: "ˈfasil" }
        , { slug: Slug "señalar", ipa: "seɲaˈlaɾ" }
        , { slug: Slug "elegir", ipa: "eleˈxiɾ" }
        , { slug: Slug "figura", ipa: "fiˈɡuɾa" }
        , { slug: Slug "principal", ipa: "pɾinsiˈpal" }
        , { slug: Slug "dormir", ipa: "doɾˈmiɾ" }
        , { slug: Slug "animal", ipa: "aniˈmal" }
        , { slug: Slug "base", ipa: "ˈbase" }
        , { slug: Slug "preparar", ipa: "pɾepaˈɾaɾ" }
        , { slug: Slug "proponer", ipa: "pɾopoˈneɾ" }
        , { slug: Slug "demostrar", ipa: "demosˈtɾaɾ" }
        , { slug: Slug "fiesta", ipa: "ˈfjesta" }
        , { slug: Slug "significar", ipa: "siɡnifiˈkaɾ" }
        , { slug: Slug "posición", ipa: "posiˈsjon" }
        , { slug: Slug "cama", ipa: "ˈkama" }
        , { slug: Slug "motivo", ipa: "moˈtibo" }
        , { slug: Slug "prueba", ipa: "ˈpɾweba" }
        , { slug: Slug "politica", ipa: "poˈlitika" }
        , { slug: Slug "nacional", ipa: "nasjoˈnal" }
        , { slug: Slug "lleno", ipa: "ˈʝeno" }
        , { slug: Slug "teléfono", ipa: "teˈlefono" }
        , { slug: Slug "reunir", ipa: "reuˈniɾ" }
        , { slug: Slug "faltar", ipa: "falˈtaɾ" }
        , { slug: Slug "equipo", ipa: "eˈkipo" }
        , { slug: Slug "dato", ipa: "ˈdato" }
        , { slug: Slug "desear", ipa: "deseˈaɾ" }
        , { slug: Slug "empresa", ipa: "emˈpɾesa" }
        , { slug: Slug "asunto", ipa: "aˈsunto" }
        , { slug: Slug "presencia", ipa: "pɾeˈsensja" }
        , { slug: Slug "suyo", ipa: "ˈsuʝo" }
        , { slug: Slug "cultura", ipa: "kulˈtuɾa" }
        , { slug: Slug "serie", ipa: "ˈseɾje" }
        , { slug: Slug "millón", ipa: "miˈʝon" }
        , { slug: Slug "enseñar", ipa: "enseˈɲaɾ" }
        , { slug: Slug "construir", ipa: "konsˈtɾwiɾ" }
        , { slug: Slug "oportunidad", ipa: "opoɾtuniˈdad" }
        , { slug: Slug "vender", ipa: "benˈdeɾ" }
        , { slug: Slug "matar", ipa: "maˈtaɾ" }
        , { slug: Slug "representar", ipa: "repɾesenˈtaɾ" }
        , { slug: Slug "desaparecer", ipa: "desapaɾeˈseɾ" }
        , { slug: Slug "mandar", ipa: "manˈdaɾ" }
        , { slug: Slug "carácter", ipa: "kaˈɾakteɾ" }
        , { slug: Slug "adónde", ipa: "aˈdonde" }
        , { slug: Slug "mayoría", ipa: "maʝoˈɾia" }
        , { slug: Slug "rojo", ipa: "ˈroxo" }
        , { slug: Slug "tras", ipa: "tɾas" }
        , { slug: Slug "superior", ipa: "supeˈɾjoɾ" }
        , { slug: Slug "andar", ipa: "anˈdaɾ" }
        , { slug: Slug "corto", ipa: "ˈkoɾto" }
        , { slug: Slug "autor", ipa: "awˈtoɾ" }
        , { slug: Slug "cuarto", ipa: "ˈkwaɾto" }
        , { slug: Slug "cielo", ipa: "ˈsjelo" }
        , { slug: Slug "conocido", ipa: "konoˈsido" }
        , { slug: Slug "preferir", ipa: "pɾefeˈɾiɾ" }
        , { slug: Slug "recuerdo", ipa: "reˈkweɾdo" }
        , { slug: Slug "asegurar", ipa: "aseɡuˈɾaɾ" }
        , { slug: Slug "perdón", ipa: "peɾˈdon" }
        , { slug: Slug "función", ipa: "funˈsjon" }
        , { slug: Slug "causa", ipa: "ˈkawsa" }
        , { slug: Slug "grave", ipa: "ˈɡɾabe" }
        , { slug: Slug "decisión", ipa: "desiˈsjon" }
        , { slug: Slug "música", ipa: "ˈmusika" }
        , { slug: Slug "extraño", ipa: "eksˈtɾaɲo" }
        , { slug: Slug "crecer", ipa: "kɾeˈseɾ" }
        , { slug: Slug "surgir", ipa: "suɾˈxiɾ" }
        , { slug: Slug "película", ipa: "peˈlikula" }
        , { slug: Slug "expresión", ipa: "ekspɾeˈsjon" }
        , { slug: Slug "marido", ipa: "maˈɾido" }
        , { slug: Slug "alrededor", ipa: "alredeˈdoɾ" }
        , { slug: Slug "perro", ipa: "ˈpero" }
        , { slug: Slug "entregar", ipa: "entɾeˈɡaɾ" }
        , { slug: Slug "río", ipa: "ˈrio" }
        , { slug: Slug "exactamente", ipa: "eksaktaˈmente" }
        , { slug: Slug "seguridad", ipa: "seɡuɾiˈdad" }
        , { slug: Slug "rey", ipa: "rej" }
        , { slug: Slug "término", ipa: "ˈteɾmino" }
        , { slug: Slug "colocar", ipa: "koloˈkaɾ" }
        , { slug: Slug "metro", ipa: "ˈmetɾo" }
        , { slug: Slug "médico", ipa: "ˈmediko" }
        , { slug: Slug "habitación", ipa: "abitaˈsjon" }
        , { slug: Slug "establecer", ipa: "estableˈseɾ" }
        , { slug: Slug "guardar", ipa: "ɡwaɾˈdaɾ" }
        , { slug: Slug "arte", ipa: "ˈaɾte" }
        , { slug: Slug "par", ipa: "paɾ" }
        , { slug: Slug "iniciar", ipa: "iniˈsjaɾ" }
        , { slug: Slug "fuego", ipa: "ˈfweɡo" }
        , { slug: Slug "bajar", ipa: "baˈxaɾ" }
        , { slug: Slug "consecuencia", ipa: "konseˈkwensja" }
        , { slug: Slug "notar", ipa: "noˈtaɾ" }
        , { slug: Slug "acto", ipa: "ˈakto" }
        , { slug: Slug "meter", ipa: "meˈteɾ" }
        , { slug: Slug "absoluto", ipa: "absoˈluto" }
        , { slug: Slug "pena", ipa: "ˈpena" }
        , { slug: Slug "actuar", ipa: "akˈtwaɾ" }
        , { slug: Slug "altura", ipa: "alˈtuɾa" }
        , { slug: Slug "deseo", ipa: "deˈseo" }
        , { slug: Slug "afuera", ipa: "aˈfweɾa" }
        , { slug: Slug "precisamente", ipa: "pɾesisaˈmente" }
        , { slug: Slug "veinte", ipa: "ˈbejnte" }
        , { slug: Slug "sueño", ipa: "ˈsweɲo" }
        , { slug: Slug "pretender", ipa: "pɾetenˈdeɾ" }
        , { slug: Slug "tarea", ipa: "taˈɾea" }
        , { slug: Slug "café", ipa: "kaˈfe" }
        , { slug: Slug "carta", ipa: "ˈkaɾta" }
        , { slug: Slug "apenas", ipa: "aˈpenas" }
        , { slug: Slug "propiedad", ipa: "pɾopjeˈdad" }
        , { slug: Slug "producto", ipa: "pɾoˈdukto" }
        , { slug: Slug "personal", ipa: "peɾsoˈnal" }
        , { slug: Slug "simplemente", ipa: "simpleˈmente" }
        , { slug: Slug "imposible", ipa: "impoˈsible" }
        , { slug: Slug "gusto", ipa: "ˈɡusto" }
        , { slug: Slug "acordar(se)", ipa: "akoɾˈdaɾ" }
        , { slug: Slug "sitio", ipa: "ˈsitjo" }
        , { slug: Slug "lengua", ipa: "ˈlenɡwa" }
        , { slug: Slug "cortar", ipa: "koɾˈtaɾ" }
        , { slug: Slug "plan", ipa: "plan" }
        , { slug: Slug "bebé", ipa: "beˈbe" }
        , { slug: Slug "corresponder", ipa: "koresponˈdeɾ" }
        , { slug: Slug "romper", ipa: "romˈpeɾ" }
        , { slug: Slug "jamás", ipa: "xaˈmas" }
        , { slug: Slug "adquirir", ipa: "adkiˈɾiɾ" }
        , { slug: Slug "arma", ipa: "ˈaɾma" }
        , { slug: Slug "proyecto", ipa: "pɾoˈʝekto" }
        , { slug: Slug "memoria", ipa: "meˈmoɾja" }
        , { slug: Slug "origen", ipa: "oˈɾixen" }
        , { slug: Slug "elemento", ipa: "eleˈmento" }
        , { slug: Slug "perdido", ipa: "peɾˈdido" }
        , { slug: Slug "inglés", ipa: "inˈɡles" }
        , { slug: Slug "mercado", ipa: "meɾˈkado" }
        , { slug: Slug "curso", ipa: "ˈkuɾso" }
        , { slug: Slug "lanzar", ipa: "lanˈsaɾ" }
        , { slug: Slug "dado", ipa: "ˈdado" }
        , { slug: Slug "aprovechar", ipa: "apɾobeˈtʃaɾ" }
        , { slug: Slug "interior", ipa: "inteˈɾjoɾ" }
        , { slug: Slug "duro", ipa: "ˈduɾo" }
        , { slug: Slug "apoyar", ipa: "apoˈʝaɾ" }
        , { slug: Slug "peor", ipa: "peˈoɾ" }
        , { slug: Slug "negar", ipa: "neˈɡaɾ" }
        , { slug: Slug "avanzar", ipa: "abanˈsaɾ" }
        , { slug: Slug "uso", ipa: "ˈuso" }
        , { slug: Slug "brazo", ipa: "ˈbɾaso" }
        , { slug: Slug "profesor", ipa: "pɾofeˈsoɾ" }
        , { slug: Slug "resolver", ipa: "resolˈbeɾ" }
        , { slug: Slug "futuro", ipa: "fuˈtuɾo" }
        , { slug: Slug "mitad", ipa: "miˈtad" }
        , { slug: Slug "ropa", ipa: "ˈropa" }
        , { slug: Slug "costar", ipa: "kosˈtaɾ" }
        , { slug: Slug "rico", ipa: "ˈriko" }
        , { slug: Slug "total", ipa: "toˈtal" }
        , { slug: Slug "exigir", ipa: "eksiˈxiɾ" }
        , { slug: Slug "opinión", ipa: "opiˈnjon" }
        , { slug: Slug "aumentar", ipa: "awmenˈtaɾ" }
        , { slug: Slug "recoger", ipa: "rekoˈxeɾ" }
        , { slug: Slug "boca", ipa: "ˈboka" }
        , { slug: Slug "dirección", ipa: "diɾekˈsjon" }
        , { slug: Slug "puro", ipa: "ˈpuɾo" }
        , { slug: Slug "presidente", ipa: "pɾesiˈdente" }
        , { slug: Slug "abandonar", ipa: "abandoˈnaɾ" }
        , { slug: Slug "pieza", ipa: "ˈpjesa" }
        , { slug: Slug "anoche", ipa: "aˈnotʃe" }
        , { slug: Slug "profesional", ipa: "pɾofesjoˈnal" }
        , { slug: Slug "imponer", ipa: "impoˈneɾ" }
        , { slug: Slug "acerca", ipa: "aˈseɾka" }
        , { slug: Slug "obligar", ipa: "obliˈɡaɾ" }
        , { slug: Slug "físico", ipa: "ˈfisiko" }
        , { slug: Slug "actitud", ipa: "aktiˈtud" }
        , { slug: Slug "mar", ipa: "maɾ" }
        , { slug: Slug "entrada", ipa: "enˈtɾada" }
        , { slug: Slug "contacto", ipa: "konˈtakto" }
        , { slug: Slug "aplicar", ipa: "apliˈkaɾ" }
        , { slug: Slug "correcto", ipa: "koˈrekto" }
        , { slug: Slug "capital", ipa: "kapiˈtal" }
        , { slug: Slug "título", ipa: "ˈtitulo" }
        , { slug: Slug "detrás", ipa: "deˈtɾas" }
        , { slug: Slug "puesto", ipa: "ˈpwesto" }
        , { slug: Slug "material", ipa: "mateˈɾjal" }
        , { slug: Slug "golpe", ipa: "ˈɡolpe" }
        , { slug: Slug "disponer", ipa: "dispoˈneɾ" }
        , { slug: Slug "comunicación", ipa: "komunikaˈsjon" }
        , { slug: Slug "expresar", ipa: "ekspɾeˈsaɾ" }
        , { slug: Slug "disculpe", ipa: "disˈkulpe" }
        , { slug: Slug "simple", ipa: "ˈsimple" }
        , { slug: Slug "totalmente", ipa: "totalˈmente" }
        , { slug: Slug "provocar", ipa: "pɾoboˈkaɾ" }
        , { slug: Slug "normal", ipa: "noɾˈmal" }
        , { slug: Slug "defender", ipa: "defenˈdeɾ" }
        , { slug: Slug "enfermedad", ipa: "enfeɾmeˈdad" }
        , { slug: Slug "materia", ipa: "maˈteɾja" }
        , { slug: Slug "quitar", ipa: "kiˈtaɾ" }
        , { slug: Slug "conservar", ipa: "konseɾˈbaɾ" }
        , { slug: Slug "moderno", ipa: "moˈdeɾno" }
        , { slug: Slug "hospital", ipa: "ospiˈtal" }
        , { slug: Slug "depender", ipa: "depenˈdeɾ" }
        , { slug: Slug "naturaleza", ipa: "natuɾaˈlesa" }
        , { slug: Slug "capacidad", ipa: "kapasiˈdad" }
        , { slug: Slug "actual", ipa: "akˈtwal" }
        , { slug: Slug "marcar", ipa: "maɾˈkaɾ" }
        , { slug: Slug "distancia", ipa: "disˈtansja" }
        , { slug: Slug "pleno", ipa: "ˈpleno" }
        , { slug: Slug "perfecto", ipa: "peɾˈfekto" }
        , { slug: Slug "cerrado", ipa: "seˈrado" }
        , { slug: Slug "compartir", ipa: "kompaɾˈtiɾ" }
        , { slug: Slug "tranquilo", ipa: "tɾanˈkilo" }
        , { slug: Slug "información", ipa: "infoɾmaˈsjon" }
        , { slug: Slug "ambiente", ipa: "amˈbjente" }
        , { slug: Slug "especialmente", ipa: "espesjalˈmente" }
        , { slug: Slug "desarrollo", ipa: "desaˈroʝo" }
        , { slug: Slug "sol", ipa: "sol" }
        , { slug: Slug "consistir", ipa: "konsisˈtiɾ" }
        , { slug: Slug "probablemente", ipa: "pɾobableˈmente" }
        , { slug: Slug "constituir", ipa: "konstiˈtwiɾ" }
        , { slug: Slug "ayer", ipa: "aˈʝeɾ" }
        , { slug: Slug "dispuesto", ipa: "disˈpwesto" }
        , { slug: Slug "cubrir", ipa: "kuˈbɾiɾ" }
        , { slug: Slug "funcionar", ipa: "funsjoˈnaɾ" }
        , { slug: Slug "compañero", ipa: "kompaˈɲeɾo" }
        , { slug: Slug "bonito", ipa: "boˈnito" }
        , { slug: Slug "salida", ipa: "saˈlida" }
        , { slug: Slug "caber", ipa: "kaˈbeɾ" }
        , { slug: Slug "conciencia", ipa: "konˈsjensja" }
        , { slug: Slug "atender", ipa: "atenˈdeɾ" }
        , { slug: Slug "enfermo", ipa: "enˈfeɾmo" }
        , { slug: Slug "increíble", ipa: "inkɾeˈible" }
        , { slug: Slug "insistir", ipa: "insisˈtiɾ" }
        , { slug: Slug "costumbre", ipa: "kosˈtumbɾe" }
        , { slug: Slug "tonto", ipa: "ˈtonto" }
        , { slug: Slug "noticia", ipa: "noˈtisja" }
        , { slug: Slug "circunstancia", ipa: "siɾkunsˈtansja" }
        , { slug: Slug "doler", ipa: "doˈleɾ" }
        , { slug: Slug "privado", ipa: "pɾiˈbado" }
        , { slug: Slug "estilo", ipa: "esˈtilo" }
        , { slug: Slug "precio", ipa: "ˈpɾesjo" }
        , { slug: Slug "popular", ipa: "popuˈlaɾ" }
        , { slug: Slug "sentar", ipa: "senˈtaɾ" }
        , { slug: Slug "planta", ipa: "ˈplanta" }
        , { slug: Slug "ése", ipa: "ˈese" }
        , { slug: Slug "personaje", ipa: "peɾsoˈnaxe" }
        , { slug: Slug "famoso", ipa: "faˈmoso" }
        , { slug: Slug "hambre", ipa: "ˈambɾe" }
        , { slug: Slug "éxito", ipa: "ˈeksito" }
        , { slug: Slug "merecer", ipa: "meɾeˈseɾ" }
        , { slug: Slug "edificio", ipa: "ediˈfisjo" }
        , { slug: Slug "autoridad", ipa: "awtoɾiˈdad" }
        , { slug: Slug "piedra", ipa: "ˈpjedɾa" }
        , { slug: Slug "incluir", ipa: "inˈklwiɾ" }
        , { slug: Slug "barco", ipa: "ˈbaɾko" }
        , { slug: Slug "conjunto", ipa: "konˈxunto" }
        , { slug: Slug "hotel", ipa: "oˈtel" }
        , { slug: Slug "treinta", ipa: "ˈtɾejnta" }
        , { slug: Slug "inmediato", ipa: "inmeˈdjato" }
        , { slug: Slug "cruzar", ipa: "kɾuˈsaɾ" }
        , { slug: Slug "tuyo", ipa: "ˈtuʝo" }
        , { slug: Slug "tender", ipa: "tenˈdeɾ" }
        , { slug: Slug "finalmente", ipa: "finalˈmente" }
        , { slug: Slug "anunciar", ipa: "anunˈsjaɾ" }
        , { slug: Slug "baño", ipa: "ˈbaɲo" }
        , { slug: Slug "espíritu", ipa: "esˈpiɾitu" }
        , { slug: Slug "miembro", ipa: "ˈmjembɾo" }
        , { slug: Slug "directo", ipa: "diˈɾekto" }
        , { slug: Slug "placer", ipa: "plaˈseɾ" }
        , { slug: Slug "despertar", ipa: "despeɾˈtaɾ" }
        , { slug: Slug "recurso", ipa: "reˈkuɾso" }
        , { slug: Slug "pared", ipa: "paˈɾed" }
        , { slug: Slug "error", ipa: "eˈroɾ" }
        , { slug: Slug "preciso", ipa: "pɾeˈsiso" }
        , { slug: Slug "diverso", ipa: "diˈbeɾso" }
        , { slug: Slug "dificultad", ipa: "difikulˈtad" }
        , { slug: Slug "comentar", ipa: "komenˈtaɾ" }
        , { slug: Slug "publicar", ipa: "publiˈkaɾ" }
        , { slug: Slug "familiar", ipa: "famiˈljaɾ" }
        , { slug: Slug "voluntad", ipa: "bolunˈtad" }
        , { slug: Slug "reunión", ipa: "reuˈnjon" }
        , { slug: Slug "modelo", ipa: "moˈdelo" }
        , { slug: Slug "secreto", ipa: "seˈkɾeto" }
        , { slug: Slug "cargar", ipa: "kaɾˈɡaɾ" }
        , { slug: Slug "fecha", ipa: "ˈfetʃa" }
        , { slug: Slug "participar", ipa: "paɾtisiˈpaɾ" }
        , { slug: Slug "tren", ipa: "tɾen" }
        , { slug: Slug "impedir", ipa: "impeˈdiɾ" }
        , { slug: Slug "propósito", ipa: "pɾoˈposito" }
        , { slug: Slug "salvar", ipa: "salˈbaɾ" }
        , { slug: Slug "prisa", ipa: "ˈpɾisa" }
        , { slug: Slug "grado", ipa: "ˈɡɾado" }
        , { slug: Slug "escapar", ipa: "eskaˈpaɾ" }
        , { slug: Slug "negocio", ipa: "neˈɡosjo" }
        , { slug: Slug "lucha", ipa: "ˈlutʃa" }
        , { slug: Slug "tirar", ipa: "tiˈɾaɾ" }
        , { slug: Slug "entero", ipa: "enˈteɾo" }
        , { slug: Slug "interesante", ipa: "inteɾeˈsante" }
        , { slug: Slug "amplio", ipa: "ˈampljo" }
        , { slug: Slug "silencio", ipa: "siˈlensjo" }
        , { slug: Slug "contestar", ipa: "kontesˈtaɾ" }
        , { slug: Slug "periódico", ipa: "peˈɾjodiko" }
        , { slug: Slug "preocupar", ipa: "pɾeokuˈpaɾ" }
        , { slug: Slug "maestro", ipa: "maˈestɾo" }
        , { slug: Slug "prestar", ipa: "pɾesˈtaɾ" }
        , { slug: Slug "calidad", ipa: "kaliˈdad" }
        , { slug: Slug "sal", ipa: "sal" }
        , { slug: Slug "exponer", ipa: "ekspoˈneɾ" }
        , { slug: Slug "control", ipa: "konˈtɾol" }
        , { slug: Slug "civil", ipa: "siˈbil" }
        , { slug: Slug "raro", ipa: "ˈraɾo" }
        , { slug: Slug "ciencia", ipa: "ˈsjensja" }
        , { slug: Slug "tamaño", ipa: "taˈmaɲo" }
        , { slug: Slug "cuadro", ipa: "ˈkwadɾo" }
        , { slug: Slug "caballo", ipa: "kaˈbaʝo" }
        , { slug: Slug "responsabilidad", ipa: "responsabiliˈdad" }
        , { slug: Slug "cincuenta", ipa: "sinˈkwenta" }
        , { slug: Slug "interno", ipa: "inˈteɾno" }
        , { slug: Slug "detalle", ipa: "deˈtaʝe" }
        , { slug: Slug "marcha", ipa: "ˈmaɾtʃa" }
        , { slug: Slug "nueve", ipa: "ˈnwebe" }
        , { slug: Slug "carne", ipa: "ˈkaɾne" }
        , { slug: Slug "avión", ipa: "aˈbjon" }
        , { slug: Slug "pelo", ipa: "ˈpelo" }
        , { slug: Slug "pensamiento", ipa: "pensaˈmjento" }
        , { slug: Slug "viajar", ipa: "bjaˈxaɾ" }
        , { slug: Slug "cargo", ipa: "ˈkaɾɡo" }
        , { slug: Slug "separar", ipa: "sepaˈɾaɾ" }
        , { slug: Slug "construcción", ipa: "konstɾukˈsjon" }
        , { slug: Slug "juicio", ipa: "ˈxwisjo" }
        , { slug: Slug "terreno", ipa: "teˈreno" }
        , { slug: Slug "piso", ipa: "ˈpiso" }
        , { slug: Slug "compañia", ipa: "kompaˈɲia" }
        , { slug: Slug "oro", ipa: "ˈoɾo" }
        , { slug: Slug "regresar", ipa: "reɡɾeˈsaɾ" }
        , { slug: Slug "texto", ipa: "ˈteksto" }
        , { slug: Slug "fuente", ipa: "ˈfwente" }
        , { slug: Slug "presente", ipa: "pɾeˈsente" }
        , { slug: Slug "oficial", ipa: "ofiˈsjal" }
        , { slug: Slug "difinitivo", ipa: "definiˈtibo" }
        , { slug: Slug "revista", ipa: "reˈbista" }
        , { slug: Slug "daño", ipa: "ˈdaɲo" }
        , { slug: Slug "esperanza", ipa: "espeˈɾansa" }
        , { slug: Slug "máquina", ipa: "ˈmakina" }
        , { slug: Slug "contemplar", ipa: "kontemˈplaɾ" }
        , { slug: Slug "recorrer", ipa: "rekoˈreɾ" }
        , { slug: Slug "mente", ipa: "ˈmente" }
        , { slug: Slug "frase", ipa: "ˈfɾase" }
        , { slug: Slug "ejercicio", ipa: "exeɾˈsisjo" }
        , { slug: Slug "sala", ipa: "ˈsala" }
        , { slug: Slug "durar", ipa: "duˈɾaɾ" }
        , { slug: Slug "instrumento", ipa: "instɾuˈmento" }
        , { slug: Slug "aquello", ipa: "aˈkeʝo" }
        , { slug: Slug "defensa", ipa: "deˈfensa" }
        , { slug: Slug "director", ipa: "diɾekˈtoɾ" }
        , { slug: Slug "retirar", ipa: "retiˈɾaɾ" }
        , { slug: Slug "explicación", ipa: "eksplikaˈsjon" }
        , { slug: Slug "artículo", ipa: "aɾˈtikulo" }
        , { slug: Slug "debajo", ipa: "deˈbaxo" }
        , { slug: Slug "permanecer", ipa: "peɾmaneˈseɾ" }
        , { slug: Slug "asistir", ipa: "asisˈtiɾ" }
        , { slug: Slug "doce", ipa: "ˈdose" }
        , { slug: Slug "permiso", ipa: "peɾˈmiso" }
        , { slug: Slug "radio", ipa: "ˈradjo" }
        , { slug: Slug "organizar", ipa: "oɾɡaniˈsaɾ" }
        , { slug: Slug "elección", ipa: "elekˈsjon" }
        , { slug: Slug "visita", ipa: "biˈsita" }
        , { slug: Slug "divertido", ipa: "dibeɾˈtido" }
        , { slug: Slug "contener", ipa: "konteˈneɾ" }
        , { slug: Slug "apoyo", ipa: "aˈpoʝo" }
        , { slug: Slug "árbol", ipa: "ˈaɾbol" }
        , { slug: Slug "visitar", ipa: "bisiˈtaɾ" }
        , { slug: Slug "informar", ipa: "infoɾˈmaɾ" }
        , { slug: Slug "encuentro", ipa: "enˈkwentɾo" }
        , { slug: Slug "sexo", ipa: "ˈsekso" }
        , { slug: Slug "parecido", ipa: "paɾeˈsido" }
        , { slug: Slug "corriente", ipa: "koˈrjente" }
        , { slug: Slug "amable", ipa: "aˈmable" }
        , { slug: Slug "lectura", ipa: "lekˈtuɾa" }
        , { slug: Slug "mensaje", ipa: "menˈsaxe" }
        , { slug: Slug "existencia", ipa: "eksisˈtensja" }
        , { slug: Slug "lenguaje", ipa: "lenˈɡwaxe" }
        , { slug: Slug "traje", ipa: "ˈtɾaxe" }
        , { slug: Slug "enviar", ipa: "enˈbjaɾ" }
        , { slug: Slug "alma", ipa: "ˈalma" }
        , { slug: Slug "aun", ipa: "awn" }
        , { slug: Slug "destino", ipa: "desˈtino" }
        , { slug: Slug "educación", ipa: "edukaˈsjon" }
        , { slug: Slug "cuidar", ipa: "kwiˈdaɾ" }
        , { slug: Slug "intervenir", ipa: "inteɾbeˈniɾ" }
        , { slug: Slug "cena", ipa: "ˈsena" }
        , { slug: Slug "operación", ipa: "opeɾaˈsjon" }
        , { slug: Slug "perfectamente", ipa: "peɾfektaˈmente" }
        , { slug: Slug "extender", ipa: "ekstenˈdeɾ" }
        , { slug: Slug "comprobar", ipa: "kompɾoˈbaɾ" }
        , { slug: Slug "nota", ipa: "ˈnota" }
        , { slug: Slug "particular", ipa: "paɾtikuˈlaɾ" }
        , { slug: Slug "tardar", ipa: "taɾˈdaɾ" }
        , { slug: Slug "adentro", ipa: "aˈdentɾo" }
        , { slug: Slug "militar", ipa: "miliˈtaɾ" }
        , { slug: Slug "canción", ipa: "kanˈsjon" }
        , { slug: Slug "unido", ipa: "uˈnido" }
        , { slug: Slug "discutir", ipa: "diskuˈtiɾ" }
        , { slug: Slug "temer", ipa: "teˈmeɾ" }
        , { slug: Slug "extraordinario", ipa: "ekstɾaoɾdiˈnaɾjo" }
        , { slug: Slug "teatro", ipa: "teˈatɾo" }
        , { slug: Slug "enfrentar", ipa: "enfɾenˈtaɾ" }
        , { slug: Slug "recién", ipa: "reˈsjen" }
        , { slug: Slug "media", ipa: "ˈmedja" }
        , { slug: Slug "letra", ipa: "ˈletɾa" }
        , { slug: Slug "sentimiento", ipa: "sentiˈmjento" }
        , { slug: Slug "conducir", ipa: "konduˈsiɾ" }
        , { slug: Slug "completamente", ipa: "kompletaˈmente" }
        , { slug: Slug "frío", ipa: "ˈfɾio" }
        , { slug: Slug "firmar", ipa: "fiɾˈmaɾ" }
        , { slug: Slug "solución", ipa: "soluˈsjon" }
        , { slug: Slug "salud", ipa: "saˈlud" }
        , { slug: Slug "funciona", ipa: "funˈsjona" }
        , { slug: Slug "impresión", ipa: "impɾeˈsjon" }
        , { slug: Slug "quejarse", ipa: "keˈxaɾse" }
        , { slug: Slug "intención", ipa: "intenˈsjon" }
        , { slug: Slug "ritmo", ipa: "ˈritmo" }
        , { slug: Slug "verde", ipa: "ˈbeɾde" }
        , { slug: Slug "exacto", ipa: "ekˈsakto" }
        , { slug: Slug "respetar", ipa: "respeˈtaɾ" }
        , { slug: Slug "terrible", ipa: "teˈrible" }
        , { slug: Slug "banco", ipa: "ˈbanko" }
        , { slug: Slug "vía", ipa: "ˈbia" }
        , { slug: Slug "sostener", ipa: "sosteˈneɾ" }
        , { slug: Slug "luna", ipa: "ˈluna" }
        , { slug: Slug "piel", ipa: "pjel" }
        , { slug: Slug "izquierda", ipa: "isˈkjeɾda" }
        , { slug: Slug "delante", ipa: "deˈlante" }
        , { slug: Slug "religioso", ipa: "reliˈxjoso" }
        , { slug: Slug "advertir", ipa: "adbeɾˈtiɾ" }
        , { slug: Slug "oscuro", ipa: "osˈkuɾo" }
        , { slug: Slug "investigación", ipa: "inbestiɡaˈsjon" }
        , { slug: Slug "calor", ipa: "kaˈloɾ" }
        , { slug: Slug "tienda", ipa: "ˈtjenda" }
        , { slug: Slug "conversación", ipa: "konbeɾsaˈsjon" }
        , { slug: Slug "navidad", ipa: "nabiˈdad" }
        , { slug: Slug "verano", ipa: "beˈɾano" }
        , { slug: Slug "respeto", ipa: "resˈpeto" }
        , { slug: Slug "abuelo", ipa: "aˈbwelo" }
        , { slug: Slug "norte", ipa: "ˈnoɾte" }
        , { slug: Slug "mediante", ipa: "meˈdjante" }
        , { slug: Slug "tradición", ipa: "tɾadiˈsjon" }
        , { slug: Slug "bastar", ipa: "basˈtaɾ" }
        , { slug: Slug "pareja", ipa: "paˈɾexa" }
        , { slug: Slug "población", ipa: "poblaˈsjon" }
        , { slug: Slug "abogado", ipa: "aboˈɡado" }
        , { slug: Slug "diario", ipa: "ˈdjaɾjo" }
        , { slug: Slug "honor", ipa: "oˈnoɾ" }
        , { slug: Slug "azul", ipa: "aˈsul" }
        , { slug: Slug "mencionar", ipa: "mensjoˈnaɾ" }
        , { slug: Slug "generación", ipa: "xeneɾaˈsjon" }
        , { slug: Slug "visión", ipa: "biˈsjon" }
        , { slug: Slug "concreto", ipa: "konˈkɾeto" }
        , { slug: Slug "terminado", ipa: "teɾmiˈnado" }
        , { slug: Slug "plantear", ipa: "planteˈaɾ" }
        , { slug: Slug "dejado", ipa: "deˈxado" }
        , { slug: Slug "probar", ipa: "pɾoˈbaɾ" }
        , { slug: Slug "jurar", ipa: "xuˈɾaɾ" }
        , { slug: Slug "hermoso", ipa: "eɾˈmoso" }
        , { slug: Slug "peligro", ipa: "peˈliɡɾo" }
        , { slug: Slug "confianza", ipa: "konˈfjansa" }
        , { slug: Slug "llenar", ipa: "ʝeˈnaɾ" }
        , { slug: Slug "sencillo", ipa: "senˈsiʝo" }
        , { slug: Slug "mejorar", ipa: "mexoˈɾaɾ" }
        , { slug: Slug "concepto", ipa: "konˈsepto" }
        , { slug: Slug "destacar", ipa: "destaˈkaɾ" }
        , { slug: Slug "madera", ipa: "maˈdeɾa" }
        , { slug: Slug "caminar", ipa: "kamiˈnaɾ" }
        , { slug: Slug "emplear", ipa: "empleˈaɾ" }
        , { slug: Slug "convenir", ipa: "konbeˈniɾ" }
        , { slug: Slug "energía", ipa: "eneɾˈxia" }
        , { slug: Slug "admitir", ipa: "admiˈtiɾ" }
        , { slug: Slug "encantar", ipa: "enkanˈtaɾ" }
        ]
    }
  ]
